// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/cardPattern.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dashboard_mainParent__6N-X8 {
	/* background: #052E26; */
}

.Dashboard_main__eh3nW {
	border-radius: 50px 50px 0px 0px;
	min-height: calc(100vh - 136px);
	/* margin-top: 136px; */
	padding: 56px 100px !important;
	background: #f8f8f8;
	/* overflow: hidden; */
	z-index: 10;
}

.Dashboard_showingTicketingView__cWTPj {
	margin-top: 26px !important;
	padding: 51px 65px !important;
	box-shadow: 0px -40px 4px 0px rgba(114, 34, 130, 0.25) !important;
}

.Dashboard_navBar__lJ2n0 {
	padding-left: 100px !important;
	padding-right: 100px !important;
	z-index: 100;
}

.Dashboard_fixNavBarToView__jRTwO {
	position: fixed !important;
	top: 0 !important;
	left: 0 !important;
}

.Dashboard_profileButtonCon__BC6Y4 {
	display: inline-flex;
	height: 45px;
	padding: 0 8px;
	align-items: center;
	gap: 12px;
	flex-shrink: 0;
	border-radius: 25px;
	border: 1px solid #7a7a7a;
}

.Dashboard_profileIcon__pDukT {
	width: 32px;
	height: 32px;
	border-radius: 20px;
	border: 1px solid rgba(213, 219, 229, 0.5);
	/* background: url(<path-to-image>), lightgray 50% / cover no-repeat; */
}

.Dashboard_username__zSp4V {
	color: #fff;
	text-align: center;
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px; /* 114.286% */
	letter-spacing: 0.28px;
}

.Dashboard_chevronDown__1FSeK {
	width: 24px;
	height: 24px;
}

.Dashboard_chevronDown__1FSeK.Dashboard_black__uXEMm path {
	stroke: #000 !important;
}

.Dashboard_hello__Ct9kN {
	color: #4e4e4e;
	font-family: Manrope;
	font-size: 20px;
	font-style: normal;
	font-weight: 400;
	line-height: 16px; /* 80% */
}

.Dashboard_title__gEkih {
	display: flex;
	height: 33px;
	flex-direction: column;
	justify-content: center;
	flex-shrink: 0;
	color: #000;
	font-family: Manrope;
	font-size: 30px;
	font-style: normal;
	font-weight: 700;
	line-height: 50px; /* 166.667% */
	margin-top: 20px !important;
}

.Dashboard_innerMain__UfXb6 {
	max-width: 1240px !important;
}

.Dashboard_tiles__TgFmz {
	margin-top: 52px;
}

.Dashboard_walBal__yHhwT {
	/* width: 184px; */
	height: 37px;
	flex-shrink: 0;
	color: #fff;
	font-family: Manrope;
	font-size: 18px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
}

.Dashboard_card__LuexR {
	height: 355px;
	flex-shrink: 0;
	border-radius: 15px;
	background: linear-gradient(to bottom, #073142c0, #073142c0),
		url(${___CSS_LOADER_URL_REPLACEMENT_0___}), #073142;
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	padding: 22px 25px;
}

.Dashboard_cardMiddle__7JqJe {
	gap: 10px;
}

.Dashboard_setVisibleCon__umRq8 {
	display: inline-flex;
	padding: 7px;
	align-items: flex-start;
	gap: 10px;
	width: 38px;
	height: 38px;
	border-radius: 25px;
	background: #fff;
}

.Dashboard_setVisible__xq29Z {
	width: 24px;
	height: 24px;
}

.Dashboard_currencyCon__UE4tX {
	display: flex;
	/* width: 96px; */
	height: 45px;
	padding: 0px 10px 0px 10px;
	justify-content: center;
	align-items: center;
	gap: 7px;
	flex-shrink: 0;
	border-radius: 30px;
	background: #0f4358;
}

.Dashboard_cChevronDown__67Nd- {
	width: 24px;
	height: 24px;
	flex-shrink: 0;
}

.Dashboard_flag__Jo0Q0 {
	width: 29px;
	height: 29px;
	flex-shrink: 0;
	border-radius: 50%;
}

.Dashboard_flagID__7qg8R {
	color: #fff;
	/* text-base · 16/regular */
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 150% */
	letter-spacing: -0.176px;
}

.Dashboard_cardBottom__Ro34v {
	padding-top: 25px;
	border-top: 1px solid #c6c6c6;
}

.Dashboard_cardBox__VDoFG {
	width: calc(100% - 319px);
	justify-content: space-between;
	align-items: flex-start;
}

.Dashboard_cardCon__TNaEK,
.Dashboard_transactionsCon__fUrwV {
	width: calc(50% - 9.5px);
}

.Dashboard_kycParent__YGRYA {
	width: 300px;
	/* height: 451px; */
	flex-shrink: 0;
	border-radius: 15px;
	border: 1px solid #e3e4e9;
	background: #fff;
	z-index: auto;
}

.Dashboard_walVal__Tfs9H {
	/* height: 51px; */
	flex-shrink: 0;
	color: #fff;
	font-family: Manrope;
	font-size: 40px;
	font-style: normal;
	font-weight: 800;
	line-height: 50px; /* 125% */
}

.Dashboard_cardStrike__UG5Aq {
	margin-bottom: 25px;
}

.Dashboard_withdraw__mlogK,
.Dashboard_fund__ITGp7 {
	display: flex;
	justify-content: space-evenly !important;
	gap: 15px;
	align-items: center;
	flex-shrink: 0;
	border-radius: 30px;
	background: #f2be15;
	color: #000;
	font-family: Manrope;
	font-size: 15px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px; /* 88.889% */
}

.Dashboard_withdraw__mlogK {
	padding: 16.5px 23px 16.5px 31px;
}

.Dashboard_fund__ITGp7 {
	padding: 16.5px 31px 16.5px 23px;
}

.Dashboard_notFocused__LucjL {
	color: #fff !important;
	background: #0f4358 !important;
}

.Dashboard_littleCardIcon__6m-GC {
	width: 20px;
	height: 20px;
	flex-shrink: 0;
}

.Dashboard_txn__UYWcK {
	padding: 15px 0;
}

.Dashboard_txn__UYWcK:not(.Dashboard_txn__UYWcK:last-of-type) {
	border-bottom: 1px solid #f5f5f5;
}

.Dashboard_txnIconCon__iuuZh {
	display: flex;
	width: 40px;
	height: 39px;
	align-items: center;
	gap: 10px;
	flex-shrink: 0;
	border-radius: 20px;
	border: 1px solid #e2e2e2;
}

.Dashboard_txnIcon__z-wve {
	width: 20px;
	height: 20px;
	flex-shrink: 0;
}

.Dashboard_txnDetailCon__cfn12 {
	width: calc(100% - 50px);
}

.Dashboard_txnTitle__dzUht {
	color: #2e2a2a;
	font-family: Manrope;
	font-size: 13px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
}

.Dashboard_txnAmount__CUjTG {
	color: rgba(41, 41, 41, 0.7);
	text-align: right;
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
}

.Dashboard_txnMedium__i0VDx {
	color: rgba(41, 41, 41, 0.7);
	font-family: Manrope;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}

.Dashboard_txnStatus__81Tvw {
	text-align: right;
	font-family: Manrope;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
}

.Dashboard_txnSuccess__lXtPs {
	color: #0a0;
}

.Dashboard_txnFail__S67Dp {
	color: red;
}

.Dashboard_txnsParent__5xMig {
	border-radius: 15px;
	border: 1px solid #e3e4e9;
	background: #fff;
}

.Dashboard_txnsParent__5xMig.Dashboard_bgBlank__4S\\+mg {
	border: 1px solid #f8f8f8 !important;
	background: #f8f8f8 !important;
}

.Dashboard_txnsTitleCon__NsS8D {
	color: #000;
	font-family: Manrope;
	font-size: 18px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	padding: 25px 30px 17px;
	text-transform: capitalize;
}

.Dashboard_txnsTitleCon__NsS8D:not(.Dashboard_txnsTitleCon__NsS8D:last-of-type) {
	border-bottom: 1px solid #f5f5f5;
}

.Dashboard_txnsTitleCon__NsS8D:last-of-type {
	padding: 17px 30px 25px;
	border-top: 1px solid #f5f5f5;
}

.Dashboard_cMore__7357Y {
	display: flex;
	width: 74px;
	height: 31px;
	padding-left: 0px;
	justify-content: center;
	align-items: center;
	gap: 4px;
	flex-shrink: 0;
	border-radius: 20px;
	border: 1px solid #e3e4e9;
	background: #fff;
}

.Dashboard_cMoreText__If5UO {
	color: #000;
	font-family: Manrope;
	font-size: 10px;
	font-style: normal;
	font-weight: 500;
	/* line-height: 16px; 160% */
}

.Dashboard_cMoreChevron__FbhAn {
	width: 14px;
	height: 14px;
	/* transform: rotate(-90deg); */
	flex-shrink: 0;
}

.Dashboard_txnsCon__XaVgJ {
	padding: 0 22px;
}

.Dashboard_invTitle__UMfV9 {
	color: rgba(41, 41, 41, 0.7);
	font-family: Manrope;
	font-size: 13px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	/* width: 150px; */
}

.Dashboard_preSale__7LXpT {
	color: rgba(41, 41, 41, 0.7) !important;
	font-family: Manrope !important;
	font-size: 12px !important;
	font-style: normal !important;
	font-weight: 400 !important;
	line-height: normal !important;
}

.Dashboard_invIcon__Vc6jl {
	width: 18px;
	height: 18px;
	flex-shrink: 0;
}

.Dashboard_invLocation__N\\+2QD {
	color: #4e4e4e;
	font-family: Manrope;
	font-size: 13px;
	font-style: normal;
	font-weight: 500;
	line-height: 18px; /* 138.462% */
	width: calc(210px + 10px + 18px);
}

.Dashboard_invShares__pXsro {
	color: rgba(41, 41, 41, 0.7);
	font-family: Manrope;
	font-size: 13px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	width: 120px;
}

.Dashboard_invAmount__MMjUk {
	width: 200px;
}

.Dashboard_investmentsCon__Ey\\+RR {
	margin-top: 20px;
}

.Dashboard_kycStepsCon__Z8gnF {
	padding: 15px 26px 29px 39px;
}

.Dashboard_oStatus__eQyBT {
	border-left: 1px solid #d2d2d2;
}

.Dashboard_oStatus__eQyBT:not(.Dashboard_oStatus__eQyBT:last-of-type) {
	padding: 0 0 11px 0;
}

.Dashboard_oStatusProgressed__8OTvR {
	border-color: #34c991;
}

.Dashboard_oStatusFailed__tnPOp {
	border-color: #f86156;
}

.Dashboard_oStatusExpanded__KwGfW {
	border-color: #d2d2d2;
}

.Dashboard_stepMarkCon__xc3Eg {
	/* z-index: 100; */
	color: #fff !important;
	font-family: Manrope;
	font-size: 18px;
	font-style: normal;
	font-weight: 600;
	line-height: 109.523%; /* 19.714px */
}

.Dashboard_stepMarkConRejected__aJgqr {
	background: #f86156 !important;
	color: #fff !important;
	font-family: Manrope;
	font-size: 18px;
	font-style: normal;
	font-weight: 600;
	line-height: 109.523%; /* 19.714px */
}

.Dashboard_stepMarkConPending__pTrzP {
	border: 2px solid #4e4e4e !important;
	background: rgba(73, 71, 71, 0.1) !important;
	color: #494747 !important;
	font-family: Manrope;
	border-width: 2px;
	border-color: #e0e0e9;
	border-style: solid;
	font-size: 18px;
	font-style: normal;
	font-weight: 600;
	line-height: 109.523%; /* 19.714px */
}

.Dashboard_oStatusCon__rvZws {
	display: flex;
	width: 100px;
	height: 31px;
	padding: 0px 5px 0px 15px;
	justify-content: center;
	align-items: center;
	/* gap: 6px; */
	flex-shrink: 0;
	border-radius: 10px;
	border: 1px solid #e3e4e9;
	background: #fff;
	margin-top: 14px;
}

.Dashboard_oStatusIconCon__aT4aM {
	top: 0;
	left: -20px;
	width: 40px;
	height: 50px;
}

.Dashboard_oStatusIconConInner__EHXP8 {
	height: 100%;
	background: #fff;
}

.Dashboard_oStatusTop__38HQb {
	padding: 0 0 0 29px;
	height: 50px;
}

.Dashboard_oStatusStage__rQQ0v {
	color: #4e4e4e;
	font-family: Manrope;
	font-size: 13px;
	font-style: normal;
	font-weight: 600;
	line-height: 109.523%; /* 14.238px */
}

.Dashboard_oStatusChevron__sZih- {
	width: 24px;
	height: 24px;
	flex-shrink: 0;
}

.Dashboard_oStatusFlip__YwXB8 {
	transform: rotate(180deg);
}

.Dashboard_flip90__knavp {
	transform: rotate(90deg);
}

.Dashboard_oStatusBottom__P5u3R {
	padding: 12px 27px 19px 29px;
}

.Dashboard_oStatusContinue__JL7oU {
	color: #22272f;
	font-family: Manrope;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px; /* 133.333% */
}

.Dashboard_oStatusContinueIcon__wWyIx {
	width: 20px !important;
	height: 20px !important;
}

.Dashboard_oStatusNote__u2Gzj {
	color: rgba(41, 41, 41, 0.7);
	font-family: Manrope;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%; /* 18px */
}

.Dashboard_profileGroup__nHIg3 {
	display: flex;
	width: 280px;
	bottom: -195px;
	right: 0;
	border-radius: 10px;
	border: 1px solid #e3e4e9;
	background: #fff;
	box-shadow: 0px 18px 30px 0px rgba(131, 119, 198, 0.11);
	overflow: hidden;
	/* z-index: 1000; */
}

/* .profileGroupMask {
	position: fixed;
	display: flex;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	z-index: 100;
	background: blue;
} */

.Dashboard_profileRow__nM7QO {
	display: flex;
	padding: 12px 16px;
	gap: 12px;
}

.Dashboard_userName__7B2oh {
	color: #fff;
	font-family: Manrope !important;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 150% */
	letter-spacing: -0.176px;
}

.Dashboard_userName__7B2oh.Dashboard_profileGroupDark__2lsLZ {
	color: #11181c;
}

.Dashboard_chevronDown__1FSeK.Dashboard_profileGroupDark__2lsLZ path {
	stroke: #000;
}

.Dashboard_userSubName__vd9OV {
	color: #687076;
	font-family: Manrope !important;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 20px; /* 142.857% */
	letter-spacing: -0.084px;
}

.Dashboard_userSubName__vd9OV.Dashboard_profileGroupDark__2lsLZ {
	color: #687076;
}

.Dashboard_profileRow__nM7QO:not(.Dashboard_profileRow__nM7QO:last-of-type) {
	border-bottom: 1px solid #eceef0;
}

.Dashboard_profileGroupProfileIcon__1xRex {
	width: 48px;
	height: 48px;
	border-radius: 25px;
	border: 1px solid rgba(213, 219, 229, 0.5);
}

.Dashboard_profileGoupIcon__iF98\\+ {
	width: 24px;
	height: 24px;
}

.Dashboard_profileGroupOption__xWcQs {
	align-self: stretch;
	color: #11181c;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 150% */
	letter-spacing: -0.176px;
}

.Dashboard_sTitleCon__oCBGq {
	margin-top: 15px;
}

.Dashboard_iTitle__zsQVh {
	/* width: 256px; */
	/* height: 51px; */
	flex-shrink: 0;
	color: #000;
	font-family: Manrope;
	font-size: 40px;
	font-style: normal;
	font-weight: 800;
	line-height: 50px; /* 125% */
}

.Dashboard_iProfit__1bfJz {
	color: #0a0;
	text-align: right;
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 19.2px; /* 137.143% */
	background: #00aa0033;
	padding: 5px 10px;
	border-radius: 25px;
}

.Dashboard_iNegative__mD2Jd {
	color: rgb(170, 0, 0) !important;
	background: #aa000033 !important;
}

.Dashboard_selectorCon__nfP4j {
	height: 45px;
	flex-shrink: 0;
	border-radius: 10px;
	border: 1px solid #e3e4e9;
	background: #fff;
	overflow: hidden;
	color: #515558;
	text-align: center;
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 120%; /* 16.8px */
}

.Dashboard_selectorB15__NGv3G {
	border-radius: 15px !important;
}

.Dashboard_sSelector__S7Eng {
	padding: 7px 0;
	border: none;
	background: #fff;
	height: 100%;
	/* width: 125px; */
}

.Dashboard_sPaddedSelector__n24X1 {
	padding: 13px 34px;
}

/* .sSelSpan:not(.sSelSpan:last-of-type) {
	border-right: 1px solid #e3e4e9;
	height: 100%;
} */

.Dashboard_sSelector__S7Eng span {
	height: 100%;
	padding: 0 40px;
}

.Dashboard_sSelSpan__1j-Go {
	border-right: 1px solid #e3e4e9;
}

.Dashboard_sNotSelected__ffiOK {
	background: #f6f6f6;
	color: #000;
	text-align: center;
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	line-height: 120%; /* 16.8px */
}

.Dashboard_sNotSelected__ffiOK .Dashboard_sSelSpan__1j-Go {
	border-color: #f6f6f6 !important;
}

.Dashboard_sBrowse__91F8s {
	height: 45px;
	padding: 0px 15px 0px 24px;
	gap: 30px;
	flex-shrink: 0;
	border-radius: 10px;
	border: 1px solid #052E26;
	background: #052E26;
	color: #fff;
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px; /* 114.286% */
}

.Dashboard_sBrowse__91F8s.Dashboard_angel__qS4Er {
	background: #fff !important;
	color: #000 !important;
}

.Dashboard_sPlus__dVsG6 {
	width: 24px;
	height: 24px;
	flex-shrink: 0;
}

.Dashboard_sBrowse__91F8s.Dashboard_angel__qS4Er .Dashboard_sPlus__dVsG6 path {
	fill: #fff !important;
}

.Dashboard_iPropertyParent__XbuCV {
	margin-top: 40px;
}

.Dashboard_iProperty__UmqEk {
	margin-top: 10px;
	width: 295px;
	border-radius: 20px;
	border: 1px solid #e3e4e9;
	overflow: hidden;
	padding-bottom: 15px;
	background: #fff;
}

.Dashboard_iProperty__UmqEk:hover {
	box-shadow: 0px 18px 30px 0px rgba(131, 119, 198, 0.11);
}

.Dashboard_iPropertyImage__pzf3d {
	height: 254px;
	padding: 22.5px 26.5px;
}

.Dashboard_iPropertyShares__OzizB {
	color: #fff;
	text-align: right;
	font-family: Manrope;
	font-size: 12px;
	font-style: normal;
	font-weight: 700;
	line-height: 30px; /* 250% */
	display: inline-flex;
	padding: 3px 15px;
	border-radius: 10px;
	background: #13141c;
}

.Dashboard_iPropertyDetails__JBWSB {
	display: flex;
	padding: 15px 30px 30px 30px;
	flex-direction: column;
	align-items: flex-start;
	gap: 23px;
	align-self: stretch;
	background: #fff;
}

.Dashboard_iPropertyName__VkpF0 {
	color: #13141c;
	font-family: Manrope;
	font-size: 18px;
	font-style: normal;
	font-weight: 600;
	line-height: 30px; /* 166.667% */
	text-transform: capitalize;
}

.Dashboard_iPropLeft__5utWq {
	color: #828993;
	font-family: Manrope;
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	line-height: 30px; /* 230.769% */
}

.Dashboard_iPropRight__uNxbc {
	color: #13141c;
	text-align: right;
	font-family: Manrope;
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	line-height: 30px; /* 230.769% */
}

.Dashboard_iPropertyProgress__SJ2-j {
	height: 8px !important;
	border: none !important;
	border-radius: 4px !important;
	overflow: hidden !important;
}

.Dashboard_iViewDetailsBtnCon__aLr7C {
	padding: 0 30px !important;
}

.Dashboard_iViewDetailsBtn__-SIVQ {
	border-radius: 10px;
	border: 1px solid #e3e4e9;
	background: #fff;
	color: #22272f;
	gap: initial !important;
	width: 100% !important;
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px; /* 114.286% */
}

.Dashboard_iViewDetailsBtn__-SIVQ:hover {
	background: #052E26;
	color: #fff;
}

.Dashboard_iViewDetailsBtn__-SIVQ:hover .Dashboard_sPlus__dVsG6 path {
	color: #fff;
	/* fill: #fff; */
	stroke: #fff;
}

.Dashboard_tTitle__USDFF {
	color: #000;
	font-family: Manrope;
	font-size: 30px;
	font-style: normal;
	font-weight: 700;
	line-height: 50px; /* 166.667% */
}

.Dashboard_tSubTitle__rcxbw {
	color: #828993;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 18px; /* 112.5% */
}

.Dashboard_popupCon__55Y1u {
	/* padding: 200px 10px 0; */
	min-height: 100vh !important;
	min-width: 100vw !important;
	z-index: 1000;
	top: 0;
	left: 0;
	overflow-y: scroll !important;
}

.Dashboard_popUpMask__NXl\\+2 {
	background: rgba(0, 0, 0, 0.9);
	z-index: 1;
	top: 0;
	left: 0;
}

.Dashboard_popup__V1tx6 {
	width: 100%;
	z-index: 10;
	max-width: 511px;
	/* height: 315px; */
	flex-shrink: 0;
	border: none;
	border-radius: 15px;
	background: #fff;
	margin: auto;
}

.Dashboard_popupSuccess__hTfaP {
	background: #0a0 !important;
	padding: 53px 37px 45px;
}

.Dashboard_popupTitleCon__vBKMf {
	padding: 29px 39px 21px;
	border-bottom: 1px solid #f5f5f5;
}

.Dashboard_popupTitle__q0BIG {
	color: #000;
	font-family: Manrope;
	font-size: 18px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
}

.Dashboard_popupCloseCon__2XMgC {
	display: flex;
	width: 35px;
	height: 35px;
	padding-left: 0px;
	align-items: center;
	gap: 4px;
	flex-shrink: 0;
	border-radius: 20px;
	background: #fff;
	border: 1px solid #e3e4e9;
}

.Dashboard_popupCloseConSuccess__DcPMi {
	border-color: #fff !important;
	top: 30px;
	right: 34px;
}

.Dashboard_popupClose__xhd52 {
	width: 24px;
	height: 24px;
	flex-shrink: 0;
}

.Dashboard_popupBody__wlwwI {
	padding: 21px 39px 97px;
}

.Dashboard_popupBodySuccess__hr23g {
	padding: 0 !important;
}

.Dashboard_popupCheckCon__mcPcj {
	display: flex;
	width: 95px;
	height: 95px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	flex-shrink: 0;
	border: none;
	border-radius: 50px;
	background: rgba(52, 201, 145, 0.3);
}

.Dashboard_popupCheck__RxS7w {
	width: 31px;
	height: 31px;
	flex-shrink: 0;
}

.Dashboard_popupSuccessTitle__A34cX {
	margin-top: 16px;
	color: #fff;
	text-align: center;
	font-family: Manrope;
	font-size: 25px;
	font-style: normal;
	font-weight: 600;
	line-height: 120%; /* 30px */
	width: 100%;
	max-width: 280px;
}

.Dashboard_popupSuccessMessage__naGmL {
	margin-top: 10px;
	color: #fff;
	text-align: center;
	font-family: Manrope;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 18px; /* 150% */
	width: 100%;
	max-width: 437px;
}

.Dashboard_txnTypeConParent__MwLr8 {
	padding-bottom: 21px;
	border-bottom: 1px solid #f5f5f5;
}

.Dashboard_txnTypeCon__iDmj0 {
	gap: 16px;
	border-radius: 15px;
	border: 1px solid #e3e4e9;
	background: #fff;
	padding: 19px 19px 14px;
}

.Dashboard_fundRadio__eYZXx {
	width: 24px;
	height: 24px;
	flex-shrink: 0;
}

.Dashboard_fundCTU__DDwaC {
	color: #000;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px; /* 150% */
}

.Dashboard_fundLilDes__NbolO {
	color: rgba(41, 41, 41, 0.7);
	font-family: Manrope;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}

.Dashboard_walletForm__XUM1f {
	padding-top: 18px !important;
}

.Dashboard_walletContinueCon__ycDud {
	padding-top: 17px;
}

.Dashboard_fundContinue__bBwd- {
	display: flex;
	width: 157px !important;
	height: 51px !important;
	padding: 0px 11px 0px 23px !important;
	justify-content: center;
	align-items: center;
	gap: 21px !important;
	flex-shrink: 0;
	background: #052E26 !important;
	color: #fff !important;
}

.Dashboard_fundContinue__bBwd- .Dashboard_sPlus__dVsG6 path {
	color: #fff !important;
	/* fill: #fff; */
	stroke: #fff !important;
}

.Dashboard_dateSelectorCon__MZd38 {
	border-radius: 10px;
	border: 1px solid #e3e4e9;
	background: #fff;
	width: 180px;
	position: relative;
}

.Dashboard_dateSelectorConInner__fUHd- {
	display: inline-flex;
	height: 45px;
	padding: 0px 18px;
	justify-content: center;
	align-items: center;
	gap: 7px;
	flex-shrink: 0;
}

.Dashboard_dateSelectorMonth__8rnVt {
	color: #000;
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px; /* 114.286% */
}

.Dashboard_boundsCon__QfWTE {
	position: absolute;
	top: calc(100% + 5px);
	right: 0;
	z-index: 1000;
	border: 1px solid #e3e4e9;
	border-radius: 10px;
	overflow: hidden;
}

.Dashboard_bound__d8Njr {
	display: inline-flex;
	height: 45px;
	padding: 0px 18px;
	justify-content: center;
	align-items: center;
	gap: 7px;
	flex-shrink: 0;
	border: 1px solid transparent;
	background: #fff;
	color: #000;
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px; /* 114.286% */
}

.Dashboard_bound__d8Njr:not(.Dashboard_bound__d8Njr:last-of-type) {
	border-bottom: 1px solid #e3e4e9;
}

.Dashboard_tSelectorCon__CKdmj {
	padding-top: 35px;
	padding-bottom: 31px;
}

.Dashboard_tTxnType__1th1J {
	width: 145px;
	color: rgba(41, 41, 41, 0.7);
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
}

.Dashboard_tMedium__MC\\+OJ {
	width: 250px;
	color: rgba(41, 41, 41, 0.7);
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}

.Dashboard_tTxnRecords__Kxz9P {
	gap: 100px;
}

.Dashboard_tStatus__\\+LnWE {
	font-family: Manrope;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	gap: 6px;
	width: 90px;
}

.Dashboard_tSSuccess__ygyhK {
	color: #0a0;
}

.Dashboard_tSPending__W0O2C {
	color: #7b7b7b;
}

.Dashboard_tSFailed__w4CDr {
	color: #e41d1d;
}

.Dashboard_tDate__UdeBT {
	color: rgba(41, 41, 41, 0.7);
	font-family: Manrope;
	font-size: 11.892px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	width: 95px;
}

.Dashboard_tAmount__R5BKu {
	color: rgba(41, 41, 41, 0.7);
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
}

.Dashboard_tBorder25__lv6ee {
	border-radius: 25px !important;
	padding: 20px 0 !important;
}

.Dashboard_tStatusIcon__VWilF {
	width: 14px !important;
	height: 14px !important;
}

.Dashboard_tAmountCon__03hBJ {
	width: 120px;
}

.Dashboard_tinyProfileSection__6Ehwd {
	gap: 12px;
}

.Dashboard_settingsViewCon__QRkl9 {
	margin-top: 35px;
}

.Dashboard_settingsSwitch__Seu\\+c {
	width: calc(34% - 32px);
	min-width: 235px;
	border-radius: 15px;
	border: 1px solid #e3e4e9;
	overflow: hidden;
}

.Dashboard_settingsSwitchBtn__Mezgw {
	padding: 20px 30px 20px 35px;
	color: #515558;
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 30px; /* 214.286% */
	background: #fff;
}

.Dashboard_settingSwitchBtn__tG5xo path {
	stroke: #515558 !important;
}

.Dashboard_settingsSwitchInnerTag__k1JrL {
	gap: 11px;
}

.Dashboard_settingsSwitchIcon__xguM2 {
	width: 24px;
	height: 24px;
}

.Dashboard_selectedSettings__7daDw {
	color: #0f1110 !important;
	background: #f6f6f6 !important;
}

.Dashboard_selectedSettings__7daDw path {
	stroke: #0f1110 !important;
}

.Dashboard_settingsView__wxWsz {
	width: 66%;
	max-width: calc(100% - 267px);
	border-radius: 8px;
	border: 1px solid #e3e4e9;
	background: #fff;
	padding: 23px 43px;
}

.Dashboard_settingsProfileCon__RpH5g {
	padding-bottom: 13px;
	border-bottom: 1px solid #e3e4e9;
	gap: 13px;
}

.Dashboard_settingsProfileIcon__yidim path {
	stroke: #0f1110 !important;
}

.Dashboard_settingsProfileIconCon__gb\\+4C {
	padding: 10px;
	border-radius: 20px;
	border: 1px solid #e2e2e2;
}

.Dashboard_settingsProfileTitle__tAT-f {
	color: #0f1110;
	font-family: Manrope;
	font-size: 18px;
	font-style: normal;
	font-weight: 500;
	line-height: 22px; /* 122.222% */
}

.Dashboard_settingsProfileSubTitle__wUhVI {
	color: #828993;
	font-family: Manrope;
	font-size: 11px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px; /* 145.455% */
}

.Dashboard_settingsThick__RXdKT {
	color: #0f1110;
	font-family: Manrope;
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
}

.Dashboard_settingsThickLeft__CeCL4 {
	line-height: 30px; /* 250% */
}

.Dashboard_settingsThickRight__pSYjS {
	line-height: 150%;
}

.Dashboard_settingsLight__uvqgc {
	color: #828993;
	font-family: Manrope;
	font-size: 10px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px; /* 160% */
}

.Dashboard_settingsInfo__ppAHa {
	padding: 12px 0 23px;
}

.Dashboard_settingsInfo__ppAHa:not(.Dashboard_settingsInfo__ppAHa:last-of-type) {
	border-bottom: 1px solid #e3e4e9;
}

.Dashboard_settingsInfoLeft__bsA-B {
	width: 50%;
}

.Dashboard_settingsUploadButton__Sv-VJ {
	gap: 11px;
}

.Dashboard_settingsInnerPfpCon__wZORD {
	padding: 8px;
	flex-shrink: 0;
	border-radius: 25px;
	border: 1px solid #e3e4e9;
}

.Dashboard_settingsProfileImage__2v78W {
	width: 32px;
	height: 32px;
	border-radius: 20px;
	border: 1px solid rgba(213, 219, 229, 0.5);
}

.Dashboard_settingsUploadTag__XFdU\\+ {
	height: 20px;
	padding-left: 5px;
	gap: 2px;
	flex-shrink: 0;
	border-radius: 5px;
	background: rgba(114, 34, 130, 0.1);
}

.Dashboard_settingUploadTxt__NcQid {
	color: #052E26;
	font-family: Manrope;
	font-size: 10px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px; /* 160% */
}

.Dashboard_settingsProfileArrow__Y67x5 {
	display: flex;
	width: 14px;
	height: 14px;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
}

.Dashboard_settingsViewSetViewBtn__MmQI\\+ {
	display: inline-flex;
	height: 30px;
	padding: 0 10px 0 13px;
	justify-content: center;
	align-items: center;
	gap: 7px;
	flex-shrink: 0;
	border-radius: 25px;
	border: 1px solid #e3e4e9;
	background: #fff;
}

.Dashboard_settingsViewSetViewTxt__6tmM4 {
	color: #737373;
	font-family: Manrope;
	font-size: 10px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px; /* 160% */
}

.Dashboard_settingsViewSetViewIcon__eqmym {
	display: flex;
	width: 14px;
	height: 14px;
	justify-content: center;
	align-items: center;
}

.Dashboard_settingsPasswordChangeForm__Z\\+eRR {
	width: min(341px, 100%);
}

.Dashboard_settingsPasswordInputCon__FU4oc {
	margin-top: 25px;
}

.Dashboard_settingsPasswordInputLabel__MeFBI {
	color: #666;
	font-family: Manrope;
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: 18px; /* 150% */
}

.Dashboard_settingsPasswordInput__o\\+OkC {
	display: flex;
	padding: 16px;
	flex-direction: column;
	align-items: flex-start;
	gap: 10px;
	align-self: stretch;
	border: none;
	border-bottom: 1px solid #ccc;
	background: #fff;
	color: #666;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 150% */
}

.Dashboard_settingsPasswordChangeBtn__nFAuI {
	margin-top: 30px;
	height: 60px;
	flex-shrink: 0;
	border-radius: 5px;
	border: 1px solid #052E26;
	background: #052E26;
	color: #fff;
	text-align: center;
	font-family: Manrope;
	font-size: 18px;
	font-style: normal;
	font-weight: 600;
	line-height: 36px; /* 200% */
}

.Dashboard_inputHidden__GuRfO {
	display: none;
}

.Dashboard_supportParent__K3LsZ {
	padding-top: 10px;
	width: min(670px, 100%);
}

.Dashboard_supportIcon__Ac2Lw {
	width: 128.703px;
	height: 132.594px;
	flex-shrink: 0;
}

.Dashboard_supportIntroCon__UcCyY {
	margin-top: 15px;
	width: min(554px, 100%);
}

.Dashboard_supportIntroTitle__z0Zvu {
	color: #000;
	text-align: center;
	font-family: Manrope;
	font-size: 30px;
	font-style: normal;
	font-weight: 700;
	line-height: 50px; /* 166.667% */
}

.Dashboard_supportIntroTxt__XBf\\+s {
	color: #828993;
	text-align: center;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%; /* 24px */
	width: min(554px, 100%);
}

.Dashboard_supportActionButtonCon__QatRa {
	margin-top: 27px;
	gap: 11px;
	padding-bottom: 62px;
	border-bottom: 1px solid #e3e4e9;
}

.Dashboard_supportActionButton__bvgr9 {
	display: inline-flex;
	height: 52px;
	padding: 10px 22px;
	justify-content: center;
	align-items: center;
	gap: 7px;
	flex-shrink: 0;
	border: none;
	border-radius: 25px;
}

.Dashboard_supportActionButtonPurple__WmzoT {
	background: #052E26;
}

.Dashboard_supportActionButtonBlack__8LULv {
	background: #22272f;
}

.Dashboard_supportActionButtonIcon__MMi0j {
	width: 24px;
	height: 24px;
}

.Dashboard_supportActionButtonTxt__09meB {
	color: #fff;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: 16px; /* 100% */
}

.Dashboard_supportTicketParent__a4wsA {
	padding: 14px 0 18px;
	border-bottom: 1px solid #e3e4e9;
	gap: 25px;
}

.Dashboard_supportTicketInfoCon__6JXUO {
	max-width: calc(100% - 57px - 50px - 24px);
}

.Dashboard_supportTicketIconCon__bnHMq {
	padding: 15px;
	border-radius: 25px;
	border: 1px solid #4e4e4e;
	background: rgba(73, 71, 71, 0.1);
}

.Dashboard_supportTicketIcon__Pbmm7 {
	width: 24px;
	height: 24px;
}

.Dashboard_supportTicketTitleCon__N-UBU {
	gap: 15px;
}

.Dashboard_supportTicketTitle__nhsvU {
	color: #13141c;
	font-family: Manrope;
	font-size: 18px;
	font-style: normal;
	font-weight: 500;
	line-height: 30px; /* 166.667% */
	max-width: calc(100% - 30px - 58px);
}

.Dashboard_supportTicketStatusCon__6CJvX {
	padding: 3px 10px;
	border-radius: 10px;
}

.Dashboard_supportTicketStatusOpen__DbLrq {
	color: #34c991;
	border: 1px solid #34c991;
	background: rgba(52, 201, 145, 0.1);
}

.Dashboard_supportTicketStatusClosed__W\\+qPm {
	color: #808080;
	border: 1px solid #b2b2b2;
	background: rgba(34, 39, 47, 0.1);
}

.Dashboard_supportTicketStatusTxt__vvemk {
	font-family: Manrope;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 18px */
}

.Dashboard_supportTicketMessage__c20st {
	color: #828993;
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 18px; /* 128.571% */
	max-width: min(410px, 100%);
}

.Dashboard_supportTicketChevronIcon__wfBOS {
	width: 24px;
	height: 24px;
	flex-shrink: 0;
	margin-left: auto;
}

.Dashboard_faqText__gKIj6 {
	margin-top: 57px;
	color: #000;
	text-align: center;
	font-family: Manrope;
	font-size: 26px;
	font-style: normal;
	font-weight: 700;
	line-height: 50px; /* 192.308% */
}

.Dashboard_faqs__-6SVX {
	margin-top: 20px;
}

.Dashboard_fapCon__3cBT3 {
	display: flex;
	padding: 18px 24px;
	flex-direction: column;
	align-items: flex-start;
	gap: 18px;
	align-self: stretch;
	background: #fff;
	border: none;
	border-radius: 8px;
	margin-bottom: 14px;
}

.Dashboard_faqTitle__o8yAV {
	color: #000;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 120%; /* 19.2px */
}

.Dashboard_faqIcon__48rJ4 {
	width: 24px;
	height: 24px;
}

.Dashboard_faqMessage__raax2 {
	margin-top: 23px;
	color: rgba(60, 60, 67, 0.85);
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 140%; /* 22.4px */
}

.Dashboard_ticketingViewArc__sXnQ8 {
	width: calc(100% - 108px);
	/* margin: 0 auto; */
	height: 26px;
	/* z-index: 1; */
	top: -26px;
	left: auto;
	right: auto;
	border-radius: 100px 100px 0px 0px;
	background: rgb(223, 182, 232);
}

.Dashboard_ticketingView__9WrJM {
	min-height: calc(100% - 162px);
	/* z-index: 10; */
	/* padding: 51px 65px; */
	/* border-radius: 50px 50px 0px 0px; */
	background: #f8f8f8;
	/* box-shadow: 0px -40px 4px 0px rgba(114, 34, 130, 0.25); */
}

.Dashboard_ticketingViewExit__Vw9Mb {
	height: 45px;
	padding: 0px 18px;
	gap: 7px;
	flex-shrink: 0;
	border-radius: 25px;
	border: 1px solid #e3e4e9;
	background: #fff;
}

.Dashboard_ticketingViewExitIcon__Ykpup {
	display: flex;
	width: 24px;
	height: 24px;
	justify-content: center;
	align-items: center;
}

.Dashboard_ticketingViewExitTxt__BvRcF {
	color: #000;
	font-family: Manrope;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: 16px; /* 133.333% */
}

.Dashboard_ticketingViewTicketingCon__kTGtQ {
	margin-top: 59px;
	gap: 24px;
}

.Dashboard_ticketingViewTForm__rEkVw {
	width: calc(50% - 13px);
	/* width: 577px; */
	flex-shrink: 0;
	padding: 18px 43px;
	border-radius: 15px;
	border: 1px solid #e3e4e9;
	background: #fff;
}

.Dashboard_ticketingViewTFormTitle__duDzY {
	color: #000;
	font-family: Manrope;
	font-size: 22px;
	font-style: normal;
	font-weight: 700;
	line-height: 50px; /* 227.273% */
	padding-bottom: 12px;
	border-bottom: 1px solid #e3e4e9;
}

.Dashboard_showTicketingMask__YS02Z {
	position: absolute;
	top: 0;
	left: 0;
	height: 200px;
	display: none;
}

.Dashboard_ticketingMaskActive__7HIbQ {
	display: flex;
}

.Dashboard_ticketingInputCon__2qSnH {
	padding-top: 26px;
	gap: 19px;
}

.Dashboard_ticketingViewComplaintNotice__1VFeP {
	margin-top: 8px;
	color: #666;
	font-family: Manrope;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 18px; /* 150% */
}

.Dashboard_ticketingViewFileUploadTitle__QeAp8 {
	color: #666;
	font-family: Manrope;
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	line-height: 18px; /* 150% */
	margin-bottom: 9px;
}

.Dashboard_ticketingViewSubmitBtn__LZZSc {
	margin-top: 5px;
}

.Dashboard_ticketingViewCreatedTickets__SSfp\\+ {
	width: calc(50% - 13px);
	border: none;
	padding: 18px;
	border-radius: 15px;
	background: #eee;
}

.Dashboard_ticketingViewCreatedTicketsTitle__6EgFl {
	padding-left: 26px;
	color: #000;
	font-family: Manrope;
	font-size: 22px;
	font-style: normal;
	font-weight: 700;
	line-height: 50px; /* 227.273% */
}

.Dashboard_ticketingViewCreatedTicketsCon__\\+LdX6 {
	height: 244px;
	overflow-y: scroll;
	padding: 32px 26px;
	border-radius: 8px;
	border: 1px solid #e3e4e9;
	background: #fff;
}

.Dashboard_b18__tpj1I {
	border-radius: 10px !important;
	background: #052E26;
}

.Dashboard_cashOutAmountCon__ZO29l {
	margin-top: 48px;
}

.Dashboard_cashOutAmountValueCon__KX0nM {
	color: #666;
	font-family: Manrope;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 18px; /* 150% */
	margin-top: 8px;
}

.Dashboard_emptyQuery__DYKwq {
	padding: 33px 0 44px;
}

.Dashboard_emptyQueryTitle__MmrgZ {
	color: #737373;
	text-align: center;
	font-family: Manrope;
	font-size: 18px;
	font-style: normal;
	font-weight: 600;
	line-height: 120%; /* 21.6px */
	margin-bottom: 11px;
}

.Dashboard_emptyQueryMessage__cdl1e {
	color: rgba(122, 122, 122, 0.7);
	text-align: center;
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%; /* 21px */
	width: min(360px, 100%);
	margin-bottom: 24px;
}

.Dashboard_emptyRealEstate__L959- {
	width: 88px;
	height: 88px;
	flex-shrink: 0;
	margin-bottom: 22px;
}

.Dashboard_emptyRealEstateMini__0D3ZX {
	width: 55px;
	height: 55px;
	flex-shrink: 0;
	margin-bottom: 18px;
}

.Dashboard_cta__kaqkd {
	padding: 28px 33px;
	border-color: transparent;
}

.Dashboard_ctaTitle__y63HC {
	color: #fff;
	font-family: Manrope;
	font-size: 25px;
	font-style: normal;
	font-weight: 600;
	line-height: 150%; /* 37.5px */
	margin-bottom: 16px;
}

.Dashboard_ctaText__nZ\\+k1 {
	color: rgba(255, 255, 255, 0.7);
	font-family: Manrope;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%; /* 21px */
	margin-bottom: 75px;
}

/* -----------------Media-Queries---------------------- */
@media only screen and (max-width: 950px) and (min-width: 600px) and (max-height: 440px) {
	.Dashboard_navBar__lJ2n0 {
		padding-left: 42px !important;
		padding-right: 42px !important;
	}

	.Dashboard_main__eh3nW {
		padding: 39px 40px !important;
	}

	.Dashboard_sTitleCon__oCBGq {
		margin-top: 7px;
	}

	.Dashboard_hello__Ct9kN {
		font-size: 12px;
		font-style: normal;
		font-weight: 400;
		line-height: 16px; /* 133.333% */
	}

	.Dashboard_iTitle__zsQVh {
		font-size: 25px;
		font-style: normal;
		font-weight: 800;
		line-height: 30px; /* 120% */
		height: 34px;
	}

	.Dashboard_transactionsCon__fUrwV {
		width: calc(100% - 324px);
	}

	.Dashboard_kycParent__YGRYA {
		width: 310px;
	}

	.Dashboard_sActionButtons__vI2PF {
		width: initial !important;
		margin-top: 0 !important;
	}

	.Dashboard_selectorCon__nfP4j {
		margin-bottom: 0 !important;
	}

	.Dashboard_sBrowse__91F8s:not(.Dashboard_sBrowse__91F8s.Dashboard_noMargin__pgcf5) {
		margin-top: 44px !important;
	}

	.Dashboard_settingsSwitch__Seu\\+c {
		width: 50%;
		margin-bottom: 23px;
	}

	.Dashboard_settingsView__wxWsz {
		width: 100%;
		max-width: initial;
	}

	.Dashboard_ticketingViewTForm__rEkVw {
		width: 100%;
		order: 2;
	}

	.Dashboard_ticketingViewCreatedTickets__SSfp\\+ {
		width: 100%;
		order: 1;
	}
}

@media only screen and (max-width: 900px) and (min-width: 820px) {
}

@media only screen and (max-width: 820px) {
	.Dashboard_navBar__lJ2n0 {
		padding-left: 42px !important;
		padding-right: 42px !important;
	}

	.Dashboard_main__eh3nW {
		padding: 39px 40px !important;
	}

	.Dashboard_sTitleCon__oCBGq {
		margin-top: 7px;
	}

	.Dashboard_hello__Ct9kN {
		font-size: 12px;
		font-style: normal;
		font-weight: 400;
		line-height: 16px; /* 133.333% */
	}

	.Dashboard_iTitle__zsQVh {
		font-size: 25px;
		font-style: normal;
		font-weight: 800;
		line-height: 30px; /* 120% */
		height: 34px;
	}

	.Dashboard_transactionsCon__fUrwV {
		width: calc(100% - 324px);
	}

	.Dashboard_kycParent__YGRYA {
		width: 310px;
	}

	.Dashboard_sActionButtons__vI2PF {
		width: initial !important;
		margin-top: 0 !important;
	}

	.Dashboard_selectorCon__nfP4j {
		margin-bottom: 0 !important;
	}

	.Dashboard_sBrowse__91F8s:not(.Dashboard_sBrowse__91F8s.Dashboard_noMargin__pgcf5) {
		margin-top: 44px !important;
	}

	.Dashboard_settingsSwitch__Seu\\+c {
		width: 50%;
		margin-bottom: 23px;
	}

	.Dashboard_settingsView__wxWsz {
		width: 100%;
		max-width: initial;
	}

	.Dashboard_ticketingViewTForm__rEkVw {
		width: 100%;
		order: 2;
	}

	.Dashboard_ticketingViewCreatedTickets__SSfp\\+ {
		width: 100%;
		order: 1;
	}
}

@media only screen and (max-width: 767px) and (min-width: 481px) {
}

@media only screen and (max-width: 480px) {
	.Dashboard_sActionButtons__vI2PF {
		width: 100% !important;
		margin-top: 24px !important;
	}

	.Dashboard_main__eh3nW {
		padding: 37px 30px !important;
	}

	.Dashboard_navBar__lJ2n0 {
		padding-left: 30px !important;
		padding-right: 30px !important;
	}

	.Dashboard_card__LuexR {
		padding: 11px 21.5px;
	}

	.Dashboard_walVal__Tfs9H {
		font-size: 25px;
		font-weight: 600;
		line-height: 35px;
	}

	.Dashboard_txnsCon___VLJyC {
		padding: 0 !important;
	}

	.Dashboard_transactionsCon__fUrwV {
		width: 100% !important;
	}

	.Dashboard_kycParent__YGRYA {
		width: 100% !important;
	}

	.Dashboard_dateSelectorCon__MZd38 {
		margin-top: 20px !important;
	}

	.Dashboard_tinyMonthCon__e6518 {
		/* margin-bottom: 20px !important; */
	}

	.Dashboard_selectorCon__nfP4j {
		margin-bottom: 31px;
		/* margin-bottom: 20px !important; */
	}

	.Dashboard_txnsParent___ypwFb {
		background: #f8f8f8 !important;
		border: none !important;
	}

	.Dashboard_txn__UYWcK {
		width: 100% !important;
	}

	.Dashboard_tTypeMedium__1QZue {
		flex-direction: column !important;
		justify-content: space-between !important;
		align-items: flex-start !important;
	}

	.Dashboard_sSelector__S7Eng {
		font-size: 12px;
		font-style: normal;
		font-weight: 600;
		line-height: 120%; /* 14.4px */
	}

	.Dashboard_sSelector__S7Eng:first-of-type span {
		padding-left: 28px !important;
		padding-right: 21px !important;
	}

	.Dashboard_sSelector__S7Eng:last-of-type span {
		padding-right: 28px !important;
		padding-left: 21px !important;
	}

	.Dashboard_tSelectorCon__CKdmj {
		padding-bottom: 0;
	}

	.Dashboard_sSelector__S7Eng span {
		padding-right: 21px !important;
		padding-left: 21px !important;
	}

	.Dashboard_tTxnType__1th1J {
		font-size: 13px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
	}

	.Dashboard_tMedium__MC\\+OJ {
		width: initial !important;
		font-size: 12px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
	}

	.Dashboard_tAmountCon__03hBJ {
		margin-left: auto !important;
		width: initial !important;
	}

	.Dashboard_withdraw__mlogK {
		padding: 10px 15px 10px 20px;
	}

	.Dashboard_fund__ITGp7 {
		padding: 10px 20px 10px 15px;
	}

	.Dashboard_sActionButtons__vI2PF {
		width: 100% !important;
		justify-content: center !important;
		margin-top: 24px !important;
	}

	.Dashboard_sBrowse__91F8s:not(.Dashboard_sBrowse__91F8s.Dashboard_noMargin__pgcf5) {
		margin-top: 31px !important;
	}

	.Dashboard_hello__Ct9kN {
		color: #4e4e4e;
		font-family: Manrope;
		font-size: 12px;
		font-style: normal;
		font-weight: 400;
		line-height: 16px; /* 133.333% */
		padding: 0 16px !important;
	}

	.Dashboard_sTitleCon__oCBGq {
		margin-top: 7px !important;
		padding: 0 16px !important;
	}

	.Dashboard_iTitle__zsQVh {
		color: #000;
		font-family: Manrope;
		font-size: 25px;
		font-style: normal;
		font-weight: 800;
		line-height: 30px; /* 120% */
	}

	.Dashboard_iProfit__1bfJz {
		color: #0a0;
		text-align: right;
		font-family: Manrope;
		font-size: 10px;
		font-style: normal;
		font-weight: 400;
		line-height: 19.2px; /* 192% */
	}

	.Dashboard_iProperty__UmqEk {
		width: 48.5% !important;
		/* height: 291px !important; */
		border-radius: 10px !important;
	}

	.Dashboard_iPropertyImage__pzf3d {
		height: 177px !important;
		padding: 15.5px !important;
	}

	.Dashboard_iPropertyShares__OzizB {
		color: #fff;
		font-family: Manrope;
		font-size: 8px;
		font-style: normal;
		font-weight: 700;
		line-height: 150%; /* 12px */
		padding: 5px 10px !important;
		border-radius: 5px;
	}

	.Dashboard_iPropertyDetails__JBWSB {
		padding: 10px 12px 15px !important;
	}

	.Dashboard_iPropertyName__VkpF0 {
		color: #13141c;
		font-family: Manrope;
		font-size: 11px;
		font-style: normal;
		font-weight: 600;
		line-height: 120%; /* 13.2px */
	}

	.Dashboard_iPropertyListing__fpZCm {
		margin: 11px 0 3px !important;
	}

	.Dashboard_iPropLeft__5utWq {
		color: #828993;
		font-family: Manrope;
		font-size: 9px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
	}

	.Dashboard_iPropRight__uNxbc {
		color: #13141c;
		text-align: right;
		font-family: Manrope;
		font-size: 9px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
	}

	.Dashboard_iViewDetailsBtnCon__aLr7C {
		padding: 0 12px !important;
	}

	.Dashboard_iViewDetailsBtn__-SIVQ {
		color: #22272f;
		font-family: Manrope;
		font-size: 10px;
		font-style: normal;
		font-weight: 500;
		margin: 0 !important;
		line-height: 16px; /* 160% */
		height: 30px;
		border-radius: 5px;
		border: 1px solid #e3e4e9;
		background: #fff;
	}

	.Dashboard_iPlus__02nWE {
		display: flex;
		width: 16px;
		height: 16px;
		justify-content: center;
		align-items: center;
	}

	.Dashboard_fundContinue__bBwd- {
		background: #052E26 !important;
		color: #fff !important;
	}

	.Dashboard_fundContinue__bBwd- .Dashboard_sPlus__dVsG6 path {
		color: #fff !important;
		/* fill: #fff; */
		stroke: #fff !important;
	}

	.Dashboard_settingsSwitch__Seu\\+c {
		width: 100%;
		margin-bottom: 17px;
		min-width: initial;
		border-radius: 8px;
	}

	.Dashboard_settingsView__wxWsz {
		width: 100%;
		max-width: initial;
		padding: 16px 18px;
	}

	.Dashboard_settingsSwitchTag__Z3O1v {
		font-size: 13px;
	}

	.Dashboard_settingsSwitchIcon__xguM2 {
		width: 20px;
		height: 20px;
	}

	.Dashboard_settingsProfileTitle__tAT-f {
		font-size: 15px;
	}

	.Dashboard_settingsInfoLeft__bsA-B:not(.Dashboard_settingsInfoLeft__bsA-B.Dashboard_neutral__61QvX) {
		width: 100%;
	}

	.Dashboard_settingsViewSetViewBtn__MmQI\\+ {
		margin-top: 25px;
	}

	.Dashboard_supportIcon__Ac2Lw {
		width: 80px;
		height: 82.418px;
	}

	.Dashboard_supportIntroTitle__z0Zvu {
		font-size: 20px;
		font-style: normal;
		font-weight: 700;
		line-height: 150%; /* 30px */
	}

	.Dashboard_supportIntroTxt__XBf\\+s {
		font-size: 13px;
		font-style: normal;
		font-weight: 400;
		line-height: 150%; /* 19.5px */
	}

	.Dashboard_supportActionButtonCon__QatRa {
		margin-top: 18px;
		padding-bottom: 50px;
	}

	.Dashboard_supportActionButtonIcon__MMi0j {
		width: 20px;
		height: 20px;
	}

	.Dashboard_supportActionButtonTxt__09meB {
		font-size: 14px;
	}

	.Dashboard_faqText__gKIj6 {
		font-size: 16px;
		margin-top: 44px;
	}

	.Dashboard_faqTitle__o8yAV,
	.Dashboard_faqMessage__raax2 {
		font-size: 14px;
	}

	.Dashboard_ticketingViewTForm__rEkVw {
		padding: 18px;
	}
}

@media only screen and (max-width: 480px) and (min-width: 361px) {
}

@media only screen and (max-width: 360px) {
}

@media only screen and (max-height: 380px) and (min-height: 301px) {
}

@media only screen and (max-height: 300px) {
}
`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard.module.css"],"names":[],"mappings":"AAAA;CACC,yBAAyB;AAC1B;;AAEA;CACC,gCAAgC;CAChC,+BAA+B;CAC/B,uBAAuB;CACvB,8BAA8B;CAC9B,mBAAmB;CACnB,sBAAsB;CACtB,WAAW;AACZ;;AAEA;CACC,2BAA2B;CAC3B,6BAA6B;CAC7B,iEAAiE;AAClE;;AAEA;CACC,8BAA8B;CAC9B,+BAA+B;CAC/B,YAAY;AACb;;AAEA;CACC,0BAA0B;CAC1B,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB,YAAY;CACZ,cAAc;CACd,mBAAmB;CACnB,SAAS;CACT,cAAc;CACd,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,0CAA0C;CAC1C,uEAAuE;AACxE;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;CAChC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,QAAQ;AAC5B;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,sBAAsB;CACtB,uBAAuB;CACvB,cAAc;CACd,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;CAChC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,cAAc;CACd,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,cAAc;CACd,mBAAmB;CACnB;kDACiD;CACjD,2BAA2B;CAC3B,sBAAsB;CACtB,4BAA4B;CAC5B,kBAAkB;AACnB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,oBAAoB;CACpB,YAAY;CACZ,uBAAuB;CACvB,SAAS;CACT,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,aAAa;CACb,iBAAiB;CACjB,YAAY;CACZ,0BAA0B;CAC1B,uBAAuB;CACvB,mBAAmB;CACnB,QAAQ;CACR,cAAc;CACd,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,2BAA2B;CAC3B,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;CAC5B,wBAAwB;AACzB;;AAEA;CACC,iBAAiB;CACjB,6BAA6B;AAC9B;;AAEA;CACC,yBAAyB;CACzB,8BAA8B;CAC9B,uBAAuB;AACxB;;AAEA;;CAEC,wBAAwB;AACzB;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,cAAc;CACd,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;;CAEC,aAAa;CACb,wCAAwC;CACxC,SAAS;CACT,mBAAmB;CACnB,cAAc;CACd,mBAAmB;CACnB,mBAAmB;CACnB,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,YAAY;AAChC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,sBAAsB;CACtB,8BAA8B;AAC/B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,SAAS;CACT,cAAc;CACd,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,4BAA4B;CAC5B,iBAAiB;CACjB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,4BAA4B;CAC5B,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,oCAAoC;CACpC,8BAA8B;AAC/B;;AAEA;CACC,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;CACvB,0BAA0B;AAC3B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,uBAAuB;CACvB,6BAA6B;AAC9B;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,uBAAuB;CACvB,mBAAmB;CACnB,QAAQ;CACR,cAAc;CACd,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,4BAA4B;AAC7B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,+BAA+B;CAC/B,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,4BAA4B;CAC5B,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,uCAAuC;CACvC,+BAA+B;CAC/B,0BAA0B;CAC1B,6BAA6B;CAC7B,2BAA2B;CAC3B,8BAA8B;AAC/B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;CAChC,gCAAgC;AACjC;;AAEA;CACC,4BAA4B;CAC5B,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB,EAAE,aAAa;AACrC;;AAEA;CACC,8BAA8B;CAC9B,sBAAsB;CACtB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB,EAAE,aAAa;AACrC;;AAEA;CACC,oCAAoC;CACpC,4CAA4C;CAC5C,yBAAyB;CACzB,oBAAoB;CACpB,iBAAiB;CACjB,qBAAqB;CACrB,mBAAmB;CACnB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB,EAAE,aAAa;AACrC;;AAEA;CACC,aAAa;CACb,YAAY;CACZ,YAAY;CACZ,yBAAyB;CACzB,uBAAuB;CACvB,mBAAmB;CACnB,cAAc;CACd,cAAc;CACd,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,MAAM;CACN,WAAW;CACX,WAAW;CACX,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB,EAAE,aAAa;AACrC;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC,4BAA4B;CAC5B,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CAEC,aAAa;CACb,YAAY;CACZ,cAAc;CACd,QAAQ;CACR,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;CAChB,uDAAuD;CACvD,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;;;;;;;;;GASG;;AAEH;CACC,aAAa;CACb,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,WAAW;CACX,+BAA+B;CAC/B,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;CAC5B,wBAAwB;AACzB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,cAAc;CACd,+BAA+B;CAC/B,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;CAChC,wBAAwB;AACzB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,0CAA0C;AAC3C;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;CAC5B,wBAAwB;AACzB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,cAAc;CACd,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB,EAAE,aAAa;CAClC,qBAAqB;CACrB,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,gCAAgC;CAChC,gCAAgC;AACjC;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,cAAc;CACd,YAAY;CACZ,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;;GAGG;;AAEH;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,mBAAmB;CACnB,WAAW;CACX,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,YAAY;CACZ,0BAA0B;CAC1B,SAAS;CACT,cAAc;CACd,mBAAmB;CACnB,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,2BAA2B;CAC3B,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;CAChB,oBAAoB;CACpB,gBAAgB;AACjB;;AAEA;CACC,uDAAuD;AACxD;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;CAC5B,oBAAoB;CACpB,iBAAiB;CACjB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,4BAA4B;CAC5B,sBAAsB;CACtB,uBAAuB;CACvB,SAAS;CACT,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;CAChC,0BAA0B;AAC3B;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,cAAc;CACd,iBAAiB;CACjB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;CACvB,6BAA6B;CAC7B,2BAA2B;AAC5B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;CAChB,cAAc;CACd,uBAAuB;CACvB,sBAAsB;CACtB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,2BAA2B;CAC3B,4BAA4B;CAC5B,2BAA2B;CAC3B,aAAa;CACb,MAAM;CACN,OAAO;CACP,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;CAC9B,UAAU;CACV,MAAM;CACN,OAAO;AACR;;AAEA;CACC,WAAW;CACX,WAAW;CACX,gBAAgB;CAChB,mBAAmB;CACnB,cAAc;CACd,YAAY;CACZ,mBAAmB;CACnB,gBAAgB;CAChB,YAAY;AACb;;AAEA;CACC,2BAA2B;CAC3B,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;CACvB,gCAAgC;AACjC;;AAEA;CACC,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,mBAAmB;CACnB,QAAQ;CACR,cAAc;CACd,mBAAmB;CACnB,gBAAgB;CAChB,yBAAyB;AAC1B;;AAEA;CACC,6BAA6B;CAC7B,SAAS;CACT,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,mBAAmB;CACnB,SAAS;CACT,cAAc;CACd,YAAY;CACZ,mBAAmB;CACnB,mCAAmC;AACpC;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;CAC5B,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;CAC5B,WAAW;CACX,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;CACpB,gCAAgC;AACjC;;AAEA;CACC,SAAS;CACT,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,4BAA4B;CAC5B,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,uBAAuB;CACvB,qCAAqC;CACrC,uBAAuB;CACvB,mBAAmB;CACnB,oBAAoB;CACpB,cAAc;CAId,8BAA8B;CAC9B,sBAAsB;AAJvB;;AAOA;CACC,sBAAsB;CACtB,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB,YAAY;CACZ,iBAAiB;CACjB,uBAAuB;CACvB,mBAAmB;CACnB,QAAQ;CACR,cAAc;AACf;;AAEA;CACC,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,QAAQ;CACR,aAAa;CACb,yBAAyB;CACzB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;CACpB,YAAY;CACZ,iBAAiB;CACjB,uBAAuB;CACvB,mBAAmB;CACnB,QAAQ;CACR,cAAc;CACd,6BAA6B;CAC7B,gBAAgB;CAChB,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,YAAY;CACZ,4BAA4B;CAC5B,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,4BAA4B;CAC5B,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,QAAQ;CACR,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,4BAA4B;CAC5B,oBAAoB;CACpB,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,4BAA4B;CAC5B,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,8BAA8B;CAC9B,0BAA0B;AAC3B;;AAEA;CACC,sBAAsB;CACtB,uBAAuB;AACxB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;CAChB,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,4BAA4B;CAC5B,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;CAChC,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,UAAU;CACV,6BAA6B;CAC7B,kBAAkB;CAClB,yBAAyB;CACzB,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,oBAAoB;CACpB,gCAAgC;CAChC,SAAS;AACV;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,gCAAgC;AACjC;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,mBAAmB;CACnB,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,0CAA0C;AAC3C;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,QAAQ;CACR,cAAc;CACd,kBAAkB;CAClB,mCAAmC;AACpC;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,oBAAoB;CACpB,YAAY;CACZ,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;CACnB,QAAQ;CACR,cAAc;CACd,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,aAAa;CACb,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,SAAS;CACT,mBAAmB;CACnB,YAAY;CACZ,6BAA6B;CAC7B,gBAAgB;CAChB,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;CACX,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,iBAAiB;CACjB,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;CAC5B,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;CAChB,SAAS;CACT,oBAAoB;CACpB,gCAAgC;AACjC;;AAEA;CACC,oBAAoB;CACpB,YAAY;CACZ,kBAAkB;CAClB,uBAAuB;CACvB,mBAAmB;CACnB,QAAQ;CACR,cAAc;CACd,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,oBAAoB;CACpB,gCAAgC;CAChC,SAAS;AACV;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,iCAAiC;AAClC;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;CAChC,mCAAmC;AACpC;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,mCAAmC;AACpC;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,iCAAiC;AAClC;;AAEA;CACC,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;CAChC,2BAA2B;AAC5B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,sBAAsB;CACtB,uBAAuB;CACvB,SAAS;CACT,mBAAmB;CACnB,gBAAgB;CAChB,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,WAAW;CACX,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,6BAA6B;CAC7B,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;AAC/B;;AAEA;CACC,yBAAyB;CACzB,oBAAoB;CACpB,YAAY;CACZ,gBAAgB;CAChB,UAAU;CACV,UAAU;CACV,WAAW;CACX,kCAAkC;CAClC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;CAC9B,iBAAiB;CACjB,wBAAwB;CACxB,sCAAsC;CACtC,mBAAmB;CACnB,4DAA4D;AAC7D;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,QAAQ;CACR,cAAc;CACd,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,YAAY;CACZ,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,gBAAgB;CAChB,SAAS;AACV;;AAEA;CACC,uBAAuB;CACvB,kBAAkB;CAClB,cAAc;CACd,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;CAChC,oBAAoB;CACpB,gCAAgC;AACjC;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,aAAa;CACb,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,iBAAiB;CACjB,SAAS;AACV;;AAEA;CACC,eAAe;CACf,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;AAC7B;;AAEA;CACC,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;CAC5B,kBAAkB;AACnB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,uBAAuB;CACvB,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,aAAa;AACjC;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;CAC5B,eAAe;AAChB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,cAAc;CACd,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;CAC9B,mBAAmB;AACpB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;CAC5B,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,WAAW;CACX,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,WAAW;CAC9B,mBAAmB;AACpB;;AAEA;CACC,+BAA+B;CAC/B,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,iBAAiB,EAAE,SAAS;CAC5B,mBAAmB;AACpB;;AAEA,yDAAyD;AACzD;CACC;EACC,6BAA6B;EAC7B,8BAA8B;CAC/B;;CAEA;EACC,6BAA6B;CAC9B;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;CACjC;;CAEA;EACC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,YAAY;CACb;;CAEA;EACC,yBAAyB;CAC1B;;CAEA;EACC,YAAY;CACb;;CAEA;EACC,yBAAyB;EACzB,wBAAwB;CACzB;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,UAAU;EACV,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,QAAQ;CACT;;CAEA;EACC,WAAW;EACX,QAAQ;CACT;AACD;;AAEA;AACA;;AAEA;CACC;EACC,6BAA6B;EAC7B,8BAA8B;CAC/B;;CAEA;EACC,6BAA6B;CAC9B;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;CACjC;;CAEA;EACC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,YAAY;CACb;;CAEA;EACC,yBAAyB;CAC1B;;CAEA;EACC,YAAY;CACb;;CAEA;EACC,yBAAyB;EACzB,wBAAwB;CACzB;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,UAAU;EACV,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,QAAQ;CACT;;CAEA;EACC,WAAW;EACX,QAAQ;CACT;AACD;;AAEA;AACA;;AAEA;CACC;EACC,sBAAsB;EACtB,2BAA2B;CAC5B;;CAEA;EACC,6BAA6B;CAC9B;;CAEA;EACC,6BAA6B;EAC7B,8BAA8B;CAC/B;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;CAClB;;CAEA;EACC,qBAAqB;CACtB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,oCAAoC;CACrC;;CAEA;EACC,mBAAmB;EACnB,oCAAoC;CACrC;;CAEA;EACC,8BAA8B;EAC9B,uBAAuB;CACxB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,iCAAiC;EACjC,yCAAyC;EACzC,kCAAkC;CACnC;;CAEA;EACC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;CAC/B;;CAEA;EACC,6BAA6B;EAC7B,8BAA8B;CAC/B;;CAEA;EACC,8BAA8B;EAC9B,6BAA6B;CAC9B;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,8BAA8B;EAC9B,6BAA6B;CAC9B;;CAEA;EACC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;CACpB;;CAEA;EACC,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;CACpB;;CAEA;EACC,4BAA4B;EAC5B,yBAAyB;CAC1B;;CAEA;EACC,4BAA4B;CAC7B;;CAEA;EACC,4BAA4B;CAC7B;;CAEA;EACC,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;CAC5B;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,0BAA0B;CAC3B;;CAEA;EACC,0BAA0B;EAC1B,0BAA0B;CAC3B;;CAEA;EACC,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;CAC7B;;CAEA;EACC,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB,EAAE,SAAS;CAC/B;;CAEA;EACC,uBAAuB;EACvB,8BAA8B;EAC9B,8BAA8B;CAC/B;;CAEA;EACC,wBAAwB;EACxB,0BAA0B;CAC3B;;CAEA;EACC,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,4BAA4B;EAC5B,kBAAkB;CACnB;;CAEA;EACC,kCAAkC;CACnC;;CAEA;EACC,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;CAC/B;;CAEA;EACC,6BAA6B;CAC9B;;CAEA;EACC,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;CACpB;;CAEA;EACC,0BAA0B;CAC3B;;CAEA;EACC,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB,EAAE,SAAS;EAC5B,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;CACjB;;CAEA;EACC,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;CACpB;;CAEA;EACC,8BAA8B;EAC9B,sBAAsB;CACvB;;CAEA;EACC,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;CACxB;;CAEA;EACC,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;CAC7B;;CAEA;EACC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,WAAW;CAC/B;;CAEA;EACC,gBAAgB;EAChB,oBAAoB;CACrB;;CAEA;EACC,WAAW;EACX,YAAY;CACb;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,eAAe;EACf,gBAAgB;CACjB;;CAEA;;EAEC,eAAe;CAChB;;CAEA;EACC,aAAa;CACd;AACD;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA","sourcesContent":[".mainParent {\n\t/* background: #052E26; */\n}\n\n.main {\n\tborder-radius: 50px 50px 0px 0px;\n\tmin-height: calc(100vh - 136px);\n\t/* margin-top: 136px; */\n\tpadding: 56px 100px !important;\n\tbackground: #f8f8f8;\n\t/* overflow: hidden; */\n\tz-index: 10;\n}\n\n.showingTicketingView {\n\tmargin-top: 26px !important;\n\tpadding: 51px 65px !important;\n\tbox-shadow: 0px -40px 4px 0px rgba(114, 34, 130, 0.25) !important;\n}\n\n.navBar {\n\tpadding-left: 100px !important;\n\tpadding-right: 100px !important;\n\tz-index: 100;\n}\n\n.fixNavBarToView {\n\tposition: fixed !important;\n\ttop: 0 !important;\n\tleft: 0 !important;\n}\n\n.profileButtonCon {\n\tdisplay: inline-flex;\n\theight: 45px;\n\tpadding: 0 8px;\n\talign-items: center;\n\tgap: 12px;\n\tflex-shrink: 0;\n\tborder-radius: 25px;\n\tborder: 1px solid #7a7a7a;\n}\n\n.profileIcon {\n\twidth: 32px;\n\theight: 32px;\n\tborder-radius: 20px;\n\tborder: 1px solid rgba(213, 219, 229, 0.5);\n\t/* background: url(<path-to-image>), lightgray 50% / cover no-repeat; */\n}\n\n.username {\n\tcolor: #fff;\n\ttext-align: center;\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 16px; /* 114.286% */\n\tletter-spacing: 0.28px;\n}\n\n.chevronDown {\n\twidth: 24px;\n\theight: 24px;\n}\n\n.chevronDown.black path {\n\tstroke: #000 !important;\n}\n\n.hello {\n\tcolor: #4e4e4e;\n\tfont-family: Manrope;\n\tfont-size: 20px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 16px; /* 80% */\n}\n\n.title {\n\tdisplay: flex;\n\theight: 33px;\n\tflex-direction: column;\n\tjustify-content: center;\n\tflex-shrink: 0;\n\tcolor: #000;\n\tfont-family: Manrope;\n\tfont-size: 30px;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tline-height: 50px; /* 166.667% */\n\tmargin-top: 20px !important;\n}\n\n.innerMain {\n\tmax-width: 1240px !important;\n}\n\n.tiles {\n\tmargin-top: 52px;\n}\n\n.walBal {\n\t/* width: 184px; */\n\theight: 37px;\n\tflex-shrink: 0;\n\tcolor: #fff;\n\tfont-family: Manrope;\n\tfont-size: 18px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: normal;\n}\n\n.card {\n\theight: 355px;\n\tflex-shrink: 0;\n\tborder-radius: 15px;\n\tbackground: linear-gradient(to bottom, #073142c0, #073142c0),\n\t\turl('../assets/images/cardPattern.png'), #073142;\n\tbackground-position: center;\n\tbackground-size: cover;\n\tbackground-repeat: no-repeat;\n\tpadding: 22px 25px;\n}\n\n.cardMiddle {\n\tgap: 10px;\n}\n\n.setVisibleCon {\n\tdisplay: inline-flex;\n\tpadding: 7px;\n\talign-items: flex-start;\n\tgap: 10px;\n\twidth: 38px;\n\theight: 38px;\n\tborder-radius: 25px;\n\tbackground: #fff;\n}\n\n.setVisible {\n\twidth: 24px;\n\theight: 24px;\n}\n\n.currencyCon {\n\tdisplay: flex;\n\t/* width: 96px; */\n\theight: 45px;\n\tpadding: 0px 10px 0px 10px;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 7px;\n\tflex-shrink: 0;\n\tborder-radius: 30px;\n\tbackground: #0f4358;\n}\n\n.cChevronDown {\n\twidth: 24px;\n\theight: 24px;\n\tflex-shrink: 0;\n}\n\n.flag {\n\twidth: 29px;\n\theight: 29px;\n\tflex-shrink: 0;\n\tborder-radius: 50%;\n}\n\n.flagID {\n\tcolor: #fff;\n\t/* text-base · 16/regular */\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 24px; /* 150% */\n\tletter-spacing: -0.176px;\n}\n\n.cardBottom {\n\tpadding-top: 25px;\n\tborder-top: 1px solid #c6c6c6;\n}\n\n.cardBox {\n\twidth: calc(100% - 319px);\n\tjustify-content: space-between;\n\talign-items: flex-start;\n}\n\n.cardCon,\n.transactionsCon {\n\twidth: calc(50% - 9.5px);\n}\n\n.kycParent {\n\twidth: 300px;\n\t/* height: 451px; */\n\tflex-shrink: 0;\n\tborder-radius: 15px;\n\tborder: 1px solid #e3e4e9;\n\tbackground: #fff;\n\tz-index: auto;\n}\n\n.walVal {\n\t/* height: 51px; */\n\tflex-shrink: 0;\n\tcolor: #fff;\n\tfont-family: Manrope;\n\tfont-size: 40px;\n\tfont-style: normal;\n\tfont-weight: 800;\n\tline-height: 50px; /* 125% */\n}\n\n.cardStrike {\n\tmargin-bottom: 25px;\n}\n\n.withdraw,\n.fund {\n\tdisplay: flex;\n\tjustify-content: space-evenly !important;\n\tgap: 15px;\n\talign-items: center;\n\tflex-shrink: 0;\n\tborder-radius: 30px;\n\tbackground: #f2be15;\n\tcolor: #000;\n\tfont-family: Manrope;\n\tfont-size: 15px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 16px; /* 88.889% */\n}\n\n.withdraw {\n\tpadding: 16.5px 23px 16.5px 31px;\n}\n\n.fund {\n\tpadding: 16.5px 31px 16.5px 23px;\n}\n\n.notFocused {\n\tcolor: #fff !important;\n\tbackground: #0f4358 !important;\n}\n\n.littleCardIcon {\n\twidth: 20px;\n\theight: 20px;\n\tflex-shrink: 0;\n}\n\n.txn {\n\tpadding: 15px 0;\n}\n\n.txn:not(.txn:last-of-type) {\n\tborder-bottom: 1px solid #f5f5f5;\n}\n\n.txnIconCon {\n\tdisplay: flex;\n\twidth: 40px;\n\theight: 39px;\n\talign-items: center;\n\tgap: 10px;\n\tflex-shrink: 0;\n\tborder-radius: 20px;\n\tborder: 1px solid #e2e2e2;\n}\n\n.txnIcon {\n\twidth: 20px;\n\theight: 20px;\n\tflex-shrink: 0;\n}\n\n.txnDetailCon {\n\twidth: calc(100% - 50px);\n}\n\n.txnTitle {\n\tcolor: #2e2a2a;\n\tfont-family: Manrope;\n\tfont-size: 13px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: normal;\n}\n\n.txnAmount {\n\tcolor: rgba(41, 41, 41, 0.7);\n\ttext-align: right;\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: normal;\n}\n\n.txnMedium {\n\tcolor: rgba(41, 41, 41, 0.7);\n\tfont-family: Manrope;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n}\n\n.txnStatus {\n\ttext-align: right;\n\tfont-family: Manrope;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: normal;\n}\n\n.txnSuccess {\n\tcolor: #0a0;\n}\n\n.txnFail {\n\tcolor: red;\n}\n\n.txnsParent {\n\tborder-radius: 15px;\n\tborder: 1px solid #e3e4e9;\n\tbackground: #fff;\n}\n\n.txnsParent.bgBlank {\n\tborder: 1px solid #f8f8f8 !important;\n\tbackground: #f8f8f8 !important;\n}\n\n.txnsTitleCon {\n\tcolor: #000;\n\tfont-family: Manrope;\n\tfont-size: 18px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: normal;\n\tpadding: 25px 30px 17px;\n\ttext-transform: capitalize;\n}\n\n.txnsTitleCon:not(.txnsTitleCon:last-of-type) {\n\tborder-bottom: 1px solid #f5f5f5;\n}\n\n.txnsTitleCon:last-of-type {\n\tpadding: 17px 30px 25px;\n\tborder-top: 1px solid #f5f5f5;\n}\n\n.cMore {\n\tdisplay: flex;\n\twidth: 74px;\n\theight: 31px;\n\tpadding-left: 0px;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 4px;\n\tflex-shrink: 0;\n\tborder-radius: 20px;\n\tborder: 1px solid #e3e4e9;\n\tbackground: #fff;\n}\n\n.cMoreText {\n\tcolor: #000;\n\tfont-family: Manrope;\n\tfont-size: 10px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\t/* line-height: 16px; 160% */\n}\n\n.cMoreChevron {\n\twidth: 14px;\n\theight: 14px;\n\t/* transform: rotate(-90deg); */\n\tflex-shrink: 0;\n}\n\n.txnsCon {\n\tpadding: 0 22px;\n}\n\n.invTitle {\n\tcolor: rgba(41, 41, 41, 0.7);\n\tfont-family: Manrope;\n\tfont-size: 13px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: normal;\n\t/* width: 150px; */\n}\n\n.preSale {\n\tcolor: rgba(41, 41, 41, 0.7) !important;\n\tfont-family: Manrope !important;\n\tfont-size: 12px !important;\n\tfont-style: normal !important;\n\tfont-weight: 400 !important;\n\tline-height: normal !important;\n}\n\n.invIcon {\n\twidth: 18px;\n\theight: 18px;\n\tflex-shrink: 0;\n}\n\n.invLocation {\n\tcolor: #4e4e4e;\n\tfont-family: Manrope;\n\tfont-size: 13px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 18px; /* 138.462% */\n\twidth: calc(210px + 10px + 18px);\n}\n\n.invShares {\n\tcolor: rgba(41, 41, 41, 0.7);\n\tfont-family: Manrope;\n\tfont-size: 13px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: normal;\n\twidth: 120px;\n}\n\n.invAmount {\n\twidth: 200px;\n}\n\n.investmentsCon {\n\tmargin-top: 20px;\n}\n\n.kycStepsCon {\n\tpadding: 15px 26px 29px 39px;\n}\n\n.oStatus {\n\tborder-left: 1px solid #d2d2d2;\n}\n\n.oStatus:not(.oStatus:last-of-type) {\n\tpadding: 0 0 11px 0;\n}\n\n.oStatusProgressed {\n\tborder-color: #34c991;\n}\n\n.oStatusFailed {\n\tborder-color: #f86156;\n}\n\n.oStatusExpanded {\n\tborder-color: #d2d2d2;\n}\n\n.stepMarkCon {\n\t/* z-index: 100; */\n\tcolor: #fff !important;\n\tfont-family: Manrope;\n\tfont-size: 18px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 109.523%; /* 19.714px */\n}\n\n.stepMarkConRejected {\n\tbackground: #f86156 !important;\n\tcolor: #fff !important;\n\tfont-family: Manrope;\n\tfont-size: 18px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 109.523%; /* 19.714px */\n}\n\n.stepMarkConPending {\n\tborder: 2px solid #4e4e4e !important;\n\tbackground: rgba(73, 71, 71, 0.1) !important;\n\tcolor: #494747 !important;\n\tfont-family: Manrope;\n\tborder-width: 2px;\n\tborder-color: #e0e0e9;\n\tborder-style: solid;\n\tfont-size: 18px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 109.523%; /* 19.714px */\n}\n\n.oStatusCon {\n\tdisplay: flex;\n\twidth: 100px;\n\theight: 31px;\n\tpadding: 0px 5px 0px 15px;\n\tjustify-content: center;\n\talign-items: center;\n\t/* gap: 6px; */\n\tflex-shrink: 0;\n\tborder-radius: 10px;\n\tborder: 1px solid #e3e4e9;\n\tbackground: #fff;\n\tmargin-top: 14px;\n}\n\n.oStatusIconCon {\n\ttop: 0;\n\tleft: -20px;\n\twidth: 40px;\n\theight: 50px;\n}\n\n.oStatusIconConInner {\n\theight: 100%;\n\tbackground: #fff;\n}\n\n.oStatusTop {\n\tpadding: 0 0 0 29px;\n\theight: 50px;\n}\n\n.oStatusStage {\n\tcolor: #4e4e4e;\n\tfont-family: Manrope;\n\tfont-size: 13px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 109.523%; /* 14.238px */\n}\n\n.oStatusChevron {\n\twidth: 24px;\n\theight: 24px;\n\tflex-shrink: 0;\n}\n\n.oStatusFlip {\n\ttransform: rotate(180deg);\n}\n\n.flip90 {\n\ttransform: rotate(90deg);\n}\n\n.oStatusBottom {\n\tpadding: 12px 27px 19px 29px;\n}\n\n.oStatusContinue {\n\tcolor: #22272f;\n\tfont-family: Manrope;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 16px; /* 133.333% */\n}\n\n.oStatusContinueIcon {\n\twidth: 20px !important;\n\theight: 20px !important;\n}\n\n.oStatusNote {\n\tcolor: rgba(41, 41, 41, 0.7);\n\tfont-family: Manrope;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 150%; /* 18px */\n}\n\n.profileGroup {\n\twidth: 280px;\n\tdisplay: flex;\n\twidth: 280px;\n\tbottom: -195px;\n\tright: 0;\n\tborder-radius: 10px;\n\tborder: 1px solid #e3e4e9;\n\tbackground: #fff;\n\tbox-shadow: 0px 18px 30px 0px rgba(131, 119, 198, 0.11);\n\toverflow: hidden;\n\t/* z-index: 1000; */\n}\n\n/* .profileGroupMask {\n\tposition: fixed;\n\tdisplay: flex;\n\twidth: 100%;\n\theight: 100%;\n\ttop: 0;\n\tleft: 0;\n\tz-index: 100;\n\tbackground: blue;\n} */\n\n.profileRow {\n\tdisplay: flex;\n\tpadding: 12px 16px;\n\tgap: 12px;\n}\n\n.userName {\n\tcolor: #fff;\n\tfont-family: Manrope !important;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 24px; /* 150% */\n\tletter-spacing: -0.176px;\n}\n\n.userName.profileGroupDark {\n\tcolor: #11181c;\n}\n\n.chevronDown.profileGroupDark path {\n\tstroke: #000;\n}\n\n.userSubName {\n\tcolor: #687076;\n\tfont-family: Manrope !important;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 20px; /* 142.857% */\n\tletter-spacing: -0.084px;\n}\n\n.userSubName.profileGroupDark {\n\tcolor: #687076;\n}\n\n.profileRow:not(.profileRow:last-of-type) {\n\tborder-bottom: 1px solid #eceef0;\n}\n\n.profileGroupProfileIcon {\n\twidth: 48px;\n\theight: 48px;\n\tborder-radius: 25px;\n\tborder: 1px solid rgba(213, 219, 229, 0.5);\n}\n\n.profileGoupIcon {\n\twidth: 24px;\n\theight: 24px;\n}\n\n.profileGroupOption {\n\talign-self: stretch;\n\tcolor: #11181c;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 24px; /* 150% */\n\tletter-spacing: -0.176px;\n}\n\n.sTitleCon {\n\tmargin-top: 15px;\n}\n\n.iTitle {\n\t/* width: 256px; */\n\t/* height: 51px; */\n\tflex-shrink: 0;\n\tcolor: #000;\n\tfont-family: Manrope;\n\tfont-size: 40px;\n\tfont-style: normal;\n\tfont-weight: 800;\n\tline-height: 50px; /* 125% */\n}\n\n.iProfit {\n\tcolor: #0a0;\n\ttext-align: right;\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 19.2px; /* 137.143% */\n\tbackground: #00aa0033;\n\tpadding: 5px 10px;\n\tborder-radius: 25px;\n}\n\n.iNegative {\n\tcolor: rgb(170, 0, 0) !important;\n\tbackground: #aa000033 !important;\n}\n\n.selectorCon {\n\theight: 45px;\n\tflex-shrink: 0;\n\tborder-radius: 10px;\n\tborder: 1px solid #e3e4e9;\n\tbackground: #fff;\n\toverflow: hidden;\n\tcolor: #515558;\n\ttext-align: center;\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 120%; /* 16.8px */\n}\n\n.selectorB15 {\n\tborder-radius: 15px !important;\n}\n\n.sSelector {\n\tpadding: 7px 0;\n\tborder: none;\n\tbackground: #fff;\n\theight: 100%;\n\t/* width: 125px; */\n}\n\n.sPaddedSelector {\n\tpadding: 13px 34px;\n}\n\n/* .sSelSpan:not(.sSelSpan:last-of-type) {\n\tborder-right: 1px solid #e3e4e9;\n\theight: 100%;\n} */\n\n.sSelector span {\n\theight: 100%;\n\tpadding: 0 40px;\n}\n\n.sSelSpan {\n\tborder-right: 1px solid #e3e4e9;\n}\n\n.sNotSelected {\n\tbackground: #f6f6f6;\n\tcolor: #000;\n\ttext-align: center;\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 120%; /* 16.8px */\n}\n\n.sNotSelected .sSelSpan {\n\tborder-color: #f6f6f6 !important;\n}\n\n.sBrowse {\n\theight: 45px;\n\tpadding: 0px 15px 0px 24px;\n\tgap: 30px;\n\tflex-shrink: 0;\n\tborder-radius: 10px;\n\tborder: 1px solid #052E26;\n\tbackground: #052E26;\n\tcolor: #fff;\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 16px; /* 114.286% */\n}\n\n.sBrowse.angel {\n\tbackground: #fff !important;\n\tcolor: #000 !important;\n}\n\n.sPlus {\n\twidth: 24px;\n\theight: 24px;\n\tflex-shrink: 0;\n}\n\n.sBrowse.angel .sPlus path {\n\tfill: #fff !important;\n}\n\n.iPropertyParent {\n\tmargin-top: 40px;\n}\n\n.iProperty {\n\tmargin-top: 10px;\n\twidth: 295px;\n\tborder-radius: 20px;\n\tborder: 1px solid #e3e4e9;\n\toverflow: hidden;\n\tpadding-bottom: 15px;\n\tbackground: #fff;\n}\n\n.iProperty:hover {\n\tbox-shadow: 0px 18px 30px 0px rgba(131, 119, 198, 0.11);\n}\n\n.iPropertyImage {\n\theight: 254px;\n\tpadding: 22.5px 26.5px;\n}\n\n.iPropertyShares {\n\tcolor: #fff;\n\ttext-align: right;\n\tfont-family: Manrope;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tline-height: 30px; /* 250% */\n\tdisplay: inline-flex;\n\tpadding: 3px 15px;\n\tborder-radius: 10px;\n\tbackground: #13141c;\n}\n\n.iPropertyDetails {\n\tdisplay: flex;\n\tpadding: 15px 30px 30px 30px;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tgap: 23px;\n\talign-self: stretch;\n\tbackground: #fff;\n}\n\n.iPropertyName {\n\tcolor: #13141c;\n\tfont-family: Manrope;\n\tfont-size: 18px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 30px; /* 166.667% */\n\ttext-transform: capitalize;\n}\n\n.iPropLeft {\n\tcolor: #828993;\n\tfont-family: Manrope;\n\tfont-size: 13px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 30px; /* 230.769% */\n}\n\n.iPropRight {\n\tcolor: #13141c;\n\ttext-align: right;\n\tfont-family: Manrope;\n\tfont-size: 13px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 30px; /* 230.769% */\n}\n\n.iPropertyProgress {\n\theight: 8px !important;\n\tborder: none !important;\n\tborder-radius: 4px !important;\n\toverflow: hidden !important;\n}\n\n.iViewDetailsBtnCon {\n\tpadding: 0 30px !important;\n}\n\n.iViewDetailsBtn {\n\tborder-radius: 10px;\n\tborder: 1px solid #e3e4e9;\n\tbackground: #fff;\n\tcolor: #22272f;\n\tgap: initial !important;\n\twidth: 100% !important;\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 16px; /* 114.286% */\n}\n\n.iViewDetailsBtn:hover {\n\tbackground: #052E26;\n\tcolor: #fff;\n}\n\n.iViewDetailsBtn:hover .sPlus path {\n\tcolor: #fff;\n\t/* fill: #fff; */\n\tstroke: #fff;\n}\n\n.tTitle {\n\tcolor: #000;\n\tfont-family: Manrope;\n\tfont-size: 30px;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tline-height: 50px; /* 166.667% */\n}\n\n.tSubTitle {\n\tcolor: #828993;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 18px; /* 112.5% */\n}\n\n.popupCon {\n\t/* padding: 200px 10px 0; */\n\tmin-height: 100vh !important;\n\tmin-width: 100vw !important;\n\tz-index: 1000;\n\ttop: 0;\n\tleft: 0;\n\toverflow-y: scroll !important;\n}\n\n.popUpMask {\n\tbackground: rgba(0, 0, 0, 0.9);\n\tz-index: 1;\n\ttop: 0;\n\tleft: 0;\n}\n\n.popup {\n\twidth: 100%;\n\tz-index: 10;\n\tmax-width: 511px;\n\t/* height: 315px; */\n\tflex-shrink: 0;\n\tborder: none;\n\tborder-radius: 15px;\n\tbackground: #fff;\n\tmargin: auto;\n}\n\n.popupSuccess {\n\tbackground: #0a0 !important;\n\tpadding: 53px 37px 45px;\n}\n\n.popupTitleCon {\n\tpadding: 29px 39px 21px;\n\tborder-bottom: 1px solid #f5f5f5;\n}\n\n.popupTitle {\n\tcolor: #000;\n\tfont-family: Manrope;\n\tfont-size: 18px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: normal;\n}\n\n.popupCloseCon {\n\tdisplay: flex;\n\twidth: 35px;\n\theight: 35px;\n\tpadding-left: 0px;\n\talign-items: center;\n\tgap: 4px;\n\tflex-shrink: 0;\n\tborder-radius: 20px;\n\tbackground: #fff;\n\tborder: 1px solid #e3e4e9;\n}\n\n.popupCloseConSuccess {\n\tborder-color: #fff !important;\n\ttop: 30px;\n\tright: 34px;\n}\n\n.popupClose {\n\twidth: 24px;\n\theight: 24px;\n\tflex-shrink: 0;\n}\n\n.popupBody {\n\tpadding: 21px 39px 97px;\n}\n\n.popupBodySuccess {\n\tpadding: 0 !important;\n}\n\n.popupCheckCon {\n\tdisplay: flex;\n\twidth: 95px;\n\theight: 95px;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 10px;\n\tflex-shrink: 0;\n\tborder: none;\n\tborder-radius: 50px;\n\tbackground: rgba(52, 201, 145, 0.3);\n}\n\n.popupCheck {\n\twidth: 31px;\n\theight: 31px;\n\tflex-shrink: 0;\n}\n\n.popupSuccessTitle {\n\tmargin-top: 16px;\n\tcolor: #fff;\n\ttext-align: center;\n\tfont-family: Manrope;\n\tfont-size: 25px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 120%; /* 30px */\n\twidth: 100%;\n\tmax-width: 280px;\n}\n\n.popupSuccessMessage {\n\tmargin-top: 10px;\n\tcolor: #fff;\n\ttext-align: center;\n\tfont-family: Manrope;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 18px; /* 150% */\n\twidth: 100%;\n\tmax-width: 437px;\n}\n\n.txnTypeConParent {\n\tpadding-bottom: 21px;\n\tborder-bottom: 1px solid #f5f5f5;\n}\n\n.txnTypeCon {\n\tgap: 16px;\n\tborder-radius: 15px;\n\tborder: 1px solid #e3e4e9;\n\tbackground: #fff;\n\tpadding: 19px 19px 14px;\n}\n\n.fundRadio {\n\twidth: 24px;\n\theight: 24px;\n\tflex-shrink: 0;\n}\n\n.fundCTU {\n\tcolor: #000;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 24px; /* 150% */\n}\n\n.fundLilDes {\n\tcolor: rgba(41, 41, 41, 0.7);\n\tfont-family: Manrope;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n}\n\n.walletForm {\n\tpadding-top: 18px !important;\n}\n\n.walletContinueCon {\n\tpadding-top: 17px;\n}\n\n.fundContinue {\n\tdisplay: flex;\n\twidth: 157px !important;\n\theight: 51px !important;\n\tpadding: 0px 11px 0px 23px !important;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 21px !important;\n\tflex-shrink: 0;\n}\n\n.fundContinue {\n\tbackground: #052E26 !important;\n\tcolor: #fff !important;\n}\n\n.fundContinue .sPlus path {\n\tcolor: #fff !important;\n\t/* fill: #fff; */\n\tstroke: #fff !important;\n}\n\n.dateSelectorCon {\n\tborder-radius: 10px;\n\tborder: 1px solid #e3e4e9;\n\tbackground: #fff;\n\twidth: 180px;\n\tposition: relative;\n}\n\n.dateSelectorConInner {\n\tdisplay: inline-flex;\n\theight: 45px;\n\tpadding: 0px 18px;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 7px;\n\tflex-shrink: 0;\n}\n\n.dateSelectorMonth {\n\tcolor: #000;\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 16px; /* 114.286% */\n}\n\n.boundsCon {\n\tposition: absolute;\n\ttop: calc(100% + 5px);\n\tright: 0;\n\tz-index: 1000;\n\tborder: 1px solid #e3e4e9;\n\tborder-radius: 10px;\n\toverflow: hidden;\n}\n\n.bound {\n\tdisplay: inline-flex;\n\theight: 45px;\n\tpadding: 0px 18px;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 7px;\n\tflex-shrink: 0;\n\tborder: 1px solid transparent;\n\tbackground: #fff;\n\tcolor: #000;\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 16px; /* 114.286% */\n}\n\n.bound:not(.bound:last-of-type) {\n\tborder-bottom: 1px solid #e3e4e9;\n}\n\n.tSelectorCon {\n\tpadding-top: 35px;\n\tpadding-bottom: 31px;\n}\n\n.tTxnType {\n\twidth: 145px;\n\tcolor: rgba(41, 41, 41, 0.7);\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: normal;\n}\n\n.tMedium {\n\twidth: 250px;\n\tcolor: rgba(41, 41, 41, 0.7);\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n}\n\n.tTxnRecords {\n\tgap: 100px;\n}\n\n.tStatus {\n\tfont-family: Manrope;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: normal;\n\tgap: 6px;\n\twidth: 90px;\n}\n\n.tSSuccess {\n\tcolor: #0a0;\n}\n\n.tSPending {\n\tcolor: #7b7b7b;\n}\n\n.tSFailed {\n\tcolor: #e41d1d;\n}\n\n.tDate {\n\tcolor: rgba(41, 41, 41, 0.7);\n\tfont-family: Manrope;\n\tfont-size: 11.892px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: normal;\n\twidth: 95px;\n}\n\n.tAmount {\n\tcolor: rgba(41, 41, 41, 0.7);\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: normal;\n}\n\n.tBorder25 {\n\tborder-radius: 25px !important;\n\tpadding: 20px 0 !important;\n}\n\n.tStatusIcon {\n\twidth: 14px !important;\n\theight: 14px !important;\n}\n\n.tAmountCon {\n\twidth: 120px;\n}\n\n.tinyProfileSection {\n\tgap: 12px;\n}\n\n.settingsViewCon {\n\tmargin-top: 35px;\n}\n\n.settingsSwitch {\n\twidth: calc(34% - 32px);\n\tmin-width: 235px;\n\tborder-radius: 15px;\n\tborder: 1px solid #e3e4e9;\n\toverflow: hidden;\n}\n\n.settingsSwitchBtn {\n\tpadding: 20px 30px 20px 35px;\n\tcolor: #515558;\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 30px; /* 214.286% */\n\tbackground: #fff;\n}\n\n.settingSwitchBtn path {\n\tstroke: #515558 !important;\n}\n\n.settingsSwitchInnerTag {\n\tgap: 11px;\n}\n\n.settingsSwitchIcon {\n\twidth: 24px;\n\theight: 24px;\n}\n\n.selectedSettings {\n\tcolor: #0f1110 !important;\n\tbackground: #f6f6f6 !important;\n}\n\n.selectedSettings path {\n\tstroke: #0f1110 !important;\n}\n\n.settingsView {\n\twidth: 66%;\n\tmax-width: calc(100% - 267px);\n\tborder-radius: 8px;\n\tborder: 1px solid #e3e4e9;\n\tbackground: #fff;\n\tpadding: 23px 43px;\n}\n\n.settingsProfileCon {\n\tpadding-bottom: 13px;\n\tborder-bottom: 1px solid #e3e4e9;\n\tgap: 13px;\n}\n\n.settingsProfileIcon path {\n\tstroke: #0f1110 !important;\n}\n\n.settingsProfileIconCon {\n\tpadding: 10px;\n\tborder-radius: 20px;\n\tborder: 1px solid #e2e2e2;\n}\n\n.settingsProfileTitle {\n\tcolor: #0f1110;\n\tfont-family: Manrope;\n\tfont-size: 18px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 22px; /* 122.222% */\n}\n\n.settingsProfileSubTitle {\n\tcolor: #828993;\n\tfont-family: Manrope;\n\tfont-size: 11px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 16px; /* 145.455% */\n}\n\n.settingsThick {\n\tcolor: #0f1110;\n\tfont-family: Manrope;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 600;\n}\n\n.settingsThickLeft {\n\tline-height: 30px; /* 250% */\n}\n\n.settingsThickRight {\n\tline-height: 150%;\n}\n\n.settingsLight {\n\tcolor: #828993;\n\tfont-family: Manrope;\n\tfont-size: 10px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 16px; /* 160% */\n}\n\n.settingsInfo {\n\tpadding: 12px 0 23px;\n}\n\n.settingsInfo:not(.settingsInfo:last-of-type) {\n\tborder-bottom: 1px solid #e3e4e9;\n}\n\n.settingsInfoLeft {\n\twidth: 50%;\n}\n\n.settingsUploadButton {\n\tgap: 11px;\n}\n\n.settingsInnerPfpCon {\n\tpadding: 8px;\n\tflex-shrink: 0;\n\tborder-radius: 25px;\n\tborder: 1px solid #e3e4e9;\n}\n\n.settingsProfileImage {\n\twidth: 32px;\n\theight: 32px;\n\tborder-radius: 20px;\n\tborder: 1px solid rgba(213, 219, 229, 0.5);\n}\n\n.settingsUploadTag {\n\theight: 20px;\n\tpadding-left: 5px;\n\tgap: 2px;\n\tflex-shrink: 0;\n\tborder-radius: 5px;\n\tbackground: rgba(114, 34, 130, 0.1);\n}\n\n.settingUploadTxt {\n\tcolor: #052E26;\n\tfont-family: Manrope;\n\tfont-size: 10px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 16px; /* 160% */\n}\n\n.settingsProfileArrow {\n\tdisplay: flex;\n\twidth: 14px;\n\theight: 14px;\n\tjustify-content: center;\n\talign-items: center;\n\tflex-shrink: 0;\n}\n\n.settingsViewSetViewBtn {\n\tdisplay: inline-flex;\n\theight: 30px;\n\tpadding: 0 10px 0 13px;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 7px;\n\tflex-shrink: 0;\n\tborder-radius: 25px;\n\tborder: 1px solid #e3e4e9;\n\tbackground: #fff;\n}\n\n.settingsViewSetViewTxt {\n\tcolor: #737373;\n\tfont-family: Manrope;\n\tfont-size: 10px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 16px; /* 160% */\n}\n\n.settingsViewSetViewIcon {\n\tdisplay: flex;\n\twidth: 14px;\n\theight: 14px;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.settingsPasswordChangeForm {\n\twidth: min(341px, 100%);\n}\n\n.settingsPasswordInputCon {\n\tmargin-top: 25px;\n}\n\n.settingsPasswordInputLabel {\n\tcolor: #666;\n\tfont-family: Manrope;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 18px; /* 150% */\n}\n\n.settingsPasswordInput {\n\tdisplay: flex;\n\tpadding: 16px;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tgap: 10px;\n\talign-self: stretch;\n\tborder: none;\n\tborder-bottom: 1px solid #ccc;\n\tbackground: #fff;\n\tcolor: #666;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 24px; /* 150% */\n}\n\n.settingsPasswordChangeBtn {\n\tmargin-top: 30px;\n\theight: 60px;\n\tflex-shrink: 0;\n\tborder-radius: 5px;\n\tborder: 1px solid #052E26;\n\tbackground: #052E26;\n\tcolor: #fff;\n\ttext-align: center;\n\tfont-family: Manrope;\n\tfont-size: 18px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 36px; /* 200% */\n}\n\n.inputHidden {\n\tdisplay: none;\n}\n\n.supportParent {\n\tpadding-top: 10px;\n\twidth: min(670px, 100%);\n}\n\n.supportIcon {\n\twidth: 128.703px;\n\theight: 132.594px;\n\tflex-shrink: 0;\n}\n\n.supportIntroCon {\n\tmargin-top: 15px;\n\twidth: min(554px, 100%);\n}\n\n.supportIntroTitle {\n\tcolor: #000;\n\ttext-align: center;\n\tfont-family: Manrope;\n\tfont-size: 30px;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tline-height: 50px; /* 166.667% */\n}\n\n.supportIntroTxt {\n\tcolor: #828993;\n\ttext-align: center;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 150%; /* 24px */\n\twidth: min(554px, 100%);\n}\n\n.supportActionButtonCon {\n\tmargin-top: 27px;\n\tgap: 11px;\n\tpadding-bottom: 62px;\n\tborder-bottom: 1px solid #e3e4e9;\n}\n\n.supportActionButton {\n\tdisplay: inline-flex;\n\theight: 52px;\n\tpadding: 10px 22px;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 7px;\n\tflex-shrink: 0;\n\tborder: none;\n\tborder-radius: 25px;\n}\n\n.supportActionButtonPurple {\n\tbackground: #052E26;\n}\n\n.supportActionButtonBlack {\n\tbackground: #22272f;\n}\n\n.supportActionButtonIcon {\n\twidth: 24px;\n\theight: 24px;\n}\n\n.supportActionButtonTxt {\n\tcolor: #fff;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 16px; /* 100% */\n}\n\n.supportTicketParent {\n\tpadding: 14px 0 18px;\n\tborder-bottom: 1px solid #e3e4e9;\n\tgap: 25px;\n}\n\n.supportTicketInfoCon {\n\tmax-width: calc(100% - 57px - 50px - 24px);\n}\n\n.supportTicketIconCon {\n\tpadding: 15px;\n\tborder-radius: 25px;\n\tborder: 1px solid #4e4e4e;\n\tbackground: rgba(73, 71, 71, 0.1);\n}\n\n.supportTicketIcon {\n\twidth: 24px;\n\theight: 24px;\n}\n\n.supportTicketTitleCon {\n\tgap: 15px;\n}\n\n.supportTicketTitle {\n\tcolor: #13141c;\n\tfont-family: Manrope;\n\tfont-size: 18px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 30px; /* 166.667% */\n\tmax-width: calc(100% - 30px - 58px);\n}\n\n.supportTicketStatusCon {\n\tpadding: 3px 10px;\n\tborder-radius: 10px;\n}\n\n.supportTicketStatusOpen {\n\tcolor: #34c991;\n\tborder: 1px solid #34c991;\n\tbackground: rgba(52, 201, 145, 0.1);\n}\n\n.supportTicketStatusClosed {\n\tcolor: #808080;\n\tborder: 1px solid #b2b2b2;\n\tbackground: rgba(34, 39, 47, 0.1);\n}\n\n.supportTicketStatusTxt {\n\tfont-family: Manrope;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 150%; /* 18px */\n}\n\n.supportTicketMessage {\n\tcolor: #828993;\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 18px; /* 128.571% */\n\tmax-width: min(410px, 100%);\n}\n\n.supportTicketChevronIcon {\n\twidth: 24px;\n\theight: 24px;\n\tflex-shrink: 0;\n\tmargin-left: auto;\n}\n\n.faqText {\n\tmargin-top: 57px;\n\tcolor: #000;\n\ttext-align: center;\n\tfont-family: Manrope;\n\tfont-size: 26px;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tline-height: 50px; /* 192.308% */\n}\n\n.faqs {\n\tmargin-top: 20px;\n}\n\n.fapCon {\n\tdisplay: flex;\n\tpadding: 18px 24px;\n\tflex-direction: column;\n\talign-items: flex-start;\n\tgap: 18px;\n\talign-self: stretch;\n\tbackground: #fff;\n\tborder: none;\n\tborder-radius: 8px;\n\tmargin-bottom: 14px;\n}\n\n.faqTitle {\n\tcolor: #000;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 120%; /* 19.2px */\n}\n\n.faqIcon {\n\twidth: 24px;\n\theight: 24px;\n}\n\n.faqMessage {\n\tmargin-top: 23px;\n\tcolor: rgba(60, 60, 67, 0.85);\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 140%; /* 22.4px */\n}\n\n.ticketingViewArc {\n\twidth: calc(100% - 108px);\n\t/* margin: 0 auto; */\n\theight: 26px;\n\t/* z-index: 1; */\n\ttop: -26px;\n\tleft: auto;\n\tright: auto;\n\tborder-radius: 100px 100px 0px 0px;\n\tbackground: rgb(223, 182, 232);\n}\n\n.ticketingView {\n\tmin-height: calc(100% - 162px);\n\t/* z-index: 10; */\n\t/* padding: 51px 65px; */\n\t/* border-radius: 50px 50px 0px 0px; */\n\tbackground: #f8f8f8;\n\t/* box-shadow: 0px -40px 4px 0px rgba(114, 34, 130, 0.25); */\n}\n\n.ticketingViewExit {\n\theight: 45px;\n\tpadding: 0px 18px;\n\tgap: 7px;\n\tflex-shrink: 0;\n\tborder-radius: 25px;\n\tborder: 1px solid #e3e4e9;\n\tbackground: #fff;\n}\n\n.ticketingViewExitIcon {\n\tdisplay: flex;\n\twidth: 24px;\n\theight: 24px;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.ticketingViewExitTxt {\n\tcolor: #000;\n\tfont-family: Manrope;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 16px; /* 133.333% */\n}\n\n.ticketingViewTicketingCon {\n\tmargin-top: 59px;\n\tgap: 24px;\n}\n\n.ticketingViewTForm {\n\twidth: calc(50% - 13px);\n\t/* width: 577px; */\n\tflex-shrink: 0;\n\tpadding: 18px 43px;\n\tborder-radius: 15px;\n\tborder: 1px solid #e3e4e9;\n\tbackground: #fff;\n}\n\n.ticketingViewTFormTitle {\n\tcolor: #000;\n\tfont-family: Manrope;\n\tfont-size: 22px;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tline-height: 50px; /* 227.273% */\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid #e3e4e9;\n}\n\n.showTicketingMask {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\theight: 200px;\n\tdisplay: none;\n}\n\n.ticketingMaskActive {\n\tdisplay: flex;\n}\n\n.ticketingInputCon {\n\tpadding-top: 26px;\n\tgap: 19px;\n}\n\n.ticketingViewComplaintNotice {\n\tmargin-top: 8px;\n\tcolor: #666;\n\tfont-family: Manrope;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 18px; /* 150% */\n}\n\n.ticketingViewFileUploadTitle {\n\tcolor: #666;\n\tfont-family: Manrope;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 18px; /* 150% */\n\tmargin-bottom: 9px;\n}\n\n.ticketingViewSubmitBtn {\n\tmargin-top: 5px;\n}\n\n.ticketingViewCreatedTickets {\n\twidth: calc(50% - 13px);\n\tborder: none;\n\tpadding: 18px;\n\tborder-radius: 15px;\n\tbackground: #eee;\n}\n\n.ticketingViewCreatedTicketsTitle {\n\tpadding-left: 26px;\n\tcolor: #000;\n\tfont-family: Manrope;\n\tfont-size: 22px;\n\tfont-style: normal;\n\tfont-weight: 700;\n\tline-height: 50px; /* 227.273% */\n}\n\n.ticketingViewCreatedTicketsCon {\n\theight: 244px;\n\toverflow-y: scroll;\n\tpadding: 32px 26px;\n\tborder-radius: 8px;\n\tborder: 1px solid #e3e4e9;\n\tbackground: #fff;\n}\n\n.b18 {\n\tborder-radius: 10px !important;\n\tbackground: #052E26;\n}\n\n.cashOutAmountCon {\n\tmargin-top: 48px;\n}\n\n.cashOutAmountValueCon {\n\tcolor: #666;\n\tfont-family: Manrope;\n\tfont-size: 12px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 18px; /* 150% */\n\tmargin-top: 8px;\n}\n\n.emptyQuery {\n\tpadding: 33px 0 44px;\n}\n\n.emptyQueryTitle {\n\tcolor: #737373;\n\ttext-align: center;\n\tfont-family: Manrope;\n\tfont-size: 18px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 120%; /* 21.6px */\n\tmargin-bottom: 11px;\n}\n\n.emptyQueryMessage {\n\tcolor: rgba(122, 122, 122, 0.7);\n\ttext-align: center;\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: 150%; /* 21px */\n\twidth: min(360px, 100%);\n\tmargin-bottom: 24px;\n}\n\n.emptyRealEstate {\n\twidth: 88px;\n\theight: 88px;\n\tflex-shrink: 0;\n\tmargin-bottom: 22px;\n}\n\n.emptyRealEstateMini {\n\twidth: 55px;\n\theight: 55px;\n\tflex-shrink: 0;\n\tmargin-bottom: 18px;\n}\n\n.cta {\n\tpadding: 28px 33px;\n\tborder-color: transparent;\n}\n\n.ctaTitle {\n\tcolor: #fff;\n\tfont-family: Manrope;\n\tfont-size: 25px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: 150%; /* 37.5px */\n\tmargin-bottom: 16px;\n}\n\n.ctaText {\n\tcolor: rgba(255, 255, 255, 0.7);\n\tfont-family: Manrope;\n\tfont-size: 14px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: 150%; /* 21px */\n\tmargin-bottom: 75px;\n}\n\n/* -----------------Media-Queries---------------------- */\n@media only screen and (max-width: 950px) and (min-width: 600px) and (max-height: 440px) {\n\t.navBar {\n\t\tpadding-left: 42px !important;\n\t\tpadding-right: 42px !important;\n\t}\n\n\t.main {\n\t\tpadding: 39px 40px !important;\n\t}\n\n\t.sTitleCon {\n\t\tmargin-top: 7px;\n\t}\n\n\t.hello {\n\t\tfont-size: 12px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 16px; /* 133.333% */\n\t}\n\n\t.iTitle {\n\t\tfont-size: 25px;\n\t\tfont-style: normal;\n\t\tfont-weight: 800;\n\t\tline-height: 30px; /* 120% */\n\t\theight: 34px;\n\t}\n\n\t.transactionsCon {\n\t\twidth: calc(100% - 324px);\n\t}\n\n\t.kycParent {\n\t\twidth: 310px;\n\t}\n\n\t.sActionButtons {\n\t\twidth: initial !important;\n\t\tmargin-top: 0 !important;\n\t}\n\n\t.selectorCon {\n\t\tmargin-bottom: 0 !important;\n\t}\n\n\t.sBrowse:not(.sBrowse.noMargin) {\n\t\tmargin-top: 44px !important;\n\t}\n\n\t.settingsSwitch {\n\t\twidth: 50%;\n\t\tmargin-bottom: 23px;\n\t}\n\n\t.settingsView {\n\t\twidth: 100%;\n\t\tmax-width: initial;\n\t}\n\n\t.ticketingViewTForm {\n\t\twidth: 100%;\n\t\torder: 2;\n\t}\n\n\t.ticketingViewCreatedTickets {\n\t\twidth: 100%;\n\t\torder: 1;\n\t}\n}\n\n@media only screen and (max-width: 900px) and (min-width: 820px) {\n}\n\n@media only screen and (max-width: 820px) {\n\t.navBar {\n\t\tpadding-left: 42px !important;\n\t\tpadding-right: 42px !important;\n\t}\n\n\t.main {\n\t\tpadding: 39px 40px !important;\n\t}\n\n\t.sTitleCon {\n\t\tmargin-top: 7px;\n\t}\n\n\t.hello {\n\t\tfont-size: 12px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 16px; /* 133.333% */\n\t}\n\n\t.iTitle {\n\t\tfont-size: 25px;\n\t\tfont-style: normal;\n\t\tfont-weight: 800;\n\t\tline-height: 30px; /* 120% */\n\t\theight: 34px;\n\t}\n\n\t.transactionsCon {\n\t\twidth: calc(100% - 324px);\n\t}\n\n\t.kycParent {\n\t\twidth: 310px;\n\t}\n\n\t.sActionButtons {\n\t\twidth: initial !important;\n\t\tmargin-top: 0 !important;\n\t}\n\n\t.selectorCon {\n\t\tmargin-bottom: 0 !important;\n\t}\n\n\t.sBrowse:not(.sBrowse.noMargin) {\n\t\tmargin-top: 44px !important;\n\t}\n\n\t.settingsSwitch {\n\t\twidth: 50%;\n\t\tmargin-bottom: 23px;\n\t}\n\n\t.settingsView {\n\t\twidth: 100%;\n\t\tmax-width: initial;\n\t}\n\n\t.ticketingViewTForm {\n\t\twidth: 100%;\n\t\torder: 2;\n\t}\n\n\t.ticketingViewCreatedTickets {\n\t\twidth: 100%;\n\t\torder: 1;\n\t}\n}\n\n@media only screen and (max-width: 767px) and (min-width: 481px) {\n}\n\n@media only screen and (max-width: 480px) {\n\t.sActionButtons {\n\t\twidth: 100% !important;\n\t\tmargin-top: 24px !important;\n\t}\n\n\t.main {\n\t\tpadding: 37px 30px !important;\n\t}\n\n\t.navBar {\n\t\tpadding-left: 30px !important;\n\t\tpadding-right: 30px !important;\n\t}\n\n\t.card {\n\t\tpadding: 11px 21.5px;\n\t}\n\n\t.walVal {\n\t\tfont-size: 25px;\n\t\tfont-weight: 600;\n\t\tline-height: 35px;\n\t}\n\n\t.txnsCon_ {\n\t\tpadding: 0 !important;\n\t}\n\n\t.transactionsCon {\n\t\twidth: 100% !important;\n\t}\n\n\t.kycParent {\n\t\twidth: 100% !important;\n\t}\n\n\t.dateSelectorCon {\n\t\tmargin-top: 20px !important;\n\t}\n\n\t.tinyMonthCon {\n\t\t/* margin-bottom: 20px !important; */\n\t}\n\n\t.selectorCon {\n\t\tmargin-bottom: 31px;\n\t\t/* margin-bottom: 20px !important; */\n\t}\n\n\t.txnsParent_ {\n\t\tbackground: #f8f8f8 !important;\n\t\tborder: none !important;\n\t}\n\n\t.txn {\n\t\twidth: 100% !important;\n\t}\n\n\t.tTypeMedium {\n\t\tflex-direction: column !important;\n\t\tjustify-content: space-between !important;\n\t\talign-items: flex-start !important;\n\t}\n\n\t.sSelector {\n\t\tfont-size: 12px;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 120%; /* 14.4px */\n\t}\n\n\t.sSelector:first-of-type span {\n\t\tpadding-left: 28px !important;\n\t\tpadding-right: 21px !important;\n\t}\n\n\t.sSelector:last-of-type span {\n\t\tpadding-right: 28px !important;\n\t\tpadding-left: 21px !important;\n\t}\n\n\t.tSelectorCon {\n\t\tpadding-bottom: 0;\n\t}\n\n\t.sSelector span {\n\t\tpadding-right: 21px !important;\n\t\tpadding-left: 21px !important;\n\t}\n\n\t.tTxnType {\n\t\tfont-size: 13px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: normal;\n\t}\n\n\t.tMedium {\n\t\twidth: initial !important;\n\t\tfont-size: 12px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: normal;\n\t}\n\n\t.tAmountCon {\n\t\tmargin-left: auto !important;\n\t\twidth: initial !important;\n\t}\n\n\t.withdraw {\n\t\tpadding: 10px 15px 10px 20px;\n\t}\n\n\t.fund {\n\t\tpadding: 10px 20px 10px 15px;\n\t}\n\n\t.sActionButtons {\n\t\twidth: 100% !important;\n\t\tjustify-content: center !important;\n\t\tmargin-top: 24px !important;\n\t}\n\n\t.sBrowse:not(.sBrowse.noMargin) {\n\t\tmargin-top: 31px !important;\n\t}\n\n\t.hello {\n\t\tcolor: #4e4e4e;\n\t\tfont-family: Manrope;\n\t\tfont-size: 12px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 16px; /* 133.333% */\n\t\tpadding: 0 16px !important;\n\t}\n\n\t.sTitleCon {\n\t\tmargin-top: 7px !important;\n\t\tpadding: 0 16px !important;\n\t}\n\n\t.iTitle {\n\t\tcolor: #000;\n\t\tfont-family: Manrope;\n\t\tfont-size: 25px;\n\t\tfont-style: normal;\n\t\tfont-weight: 800;\n\t\tline-height: 30px; /* 120% */\n\t}\n\n\t.iProfit {\n\t\tcolor: #0a0;\n\t\ttext-align: right;\n\t\tfont-family: Manrope;\n\t\tfont-size: 10px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 19.2px; /* 192% */\n\t}\n\n\t.iProperty {\n\t\twidth: 48.5% !important;\n\t\t/* height: 291px !important; */\n\t\tborder-radius: 10px !important;\n\t}\n\n\t.iPropertyImage {\n\t\theight: 177px !important;\n\t\tpadding: 15.5px !important;\n\t}\n\n\t.iPropertyShares {\n\t\tcolor: #fff;\n\t\tfont-family: Manrope;\n\t\tfont-size: 8px;\n\t\tfont-style: normal;\n\t\tfont-weight: 700;\n\t\tline-height: 150%; /* 12px */\n\t\tpadding: 5px 10px !important;\n\t\tborder-radius: 5px;\n\t}\n\n\t.iPropertyDetails {\n\t\tpadding: 10px 12px 15px !important;\n\t}\n\n\t.iPropertyName {\n\t\tcolor: #13141c;\n\t\tfont-family: Manrope;\n\t\tfont-size: 11px;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: 120%; /* 13.2px */\n\t}\n\n\t.iPropertyListing {\n\t\tmargin: 11px 0 3px !important;\n\t}\n\n\t.iPropLeft {\n\t\tcolor: #828993;\n\t\tfont-family: Manrope;\n\t\tfont-size: 9px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: normal;\n\t}\n\n\t.iPropRight {\n\t\tcolor: #13141c;\n\t\ttext-align: right;\n\t\tfont-family: Manrope;\n\t\tfont-size: 9px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: normal;\n\t}\n\n\t.iViewDetailsBtnCon {\n\t\tpadding: 0 12px !important;\n\t}\n\n\t.iViewDetailsBtn {\n\t\tcolor: #22272f;\n\t\tfont-family: Manrope;\n\t\tfont-size: 10px;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tmargin: 0 !important;\n\t\tline-height: 16px; /* 160% */\n\t\theight: 30px;\n\t\tborder-radius: 5px;\n\t\tborder: 1px solid #e3e4e9;\n\t\tbackground: #fff;\n\t}\n\n\t.iPlus {\n\t\tdisplay: flex;\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\n\t.fundContinue {\n\t\tbackground: #052E26 !important;\n\t\tcolor: #fff !important;\n\t}\n\n\t.fundContinue .sPlus path {\n\t\tcolor: #fff !important;\n\t\t/* fill: #fff; */\n\t\tstroke: #fff !important;\n\t}\n\n\t.settingsSwitch {\n\t\twidth: 100%;\n\t\tmargin-bottom: 17px;\n\t\tmin-width: initial;\n\t\tborder-radius: 8px;\n\t}\n\n\t.settingsView {\n\t\twidth: 100%;\n\t\tmax-width: initial;\n\t\tpadding: 16px 18px;\n\t}\n\n\t.settingsSwitchTag {\n\t\tfont-size: 13px;\n\t}\n\n\t.settingsSwitchIcon {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t}\n\n\t.settingsProfileTitle {\n\t\tfont-size: 15px;\n\t}\n\n\t.settingsInfoLeft:not(.settingsInfoLeft.neutral) {\n\t\twidth: 100%;\n\t}\n\n\t.settingsViewSetViewBtn {\n\t\tmargin-top: 25px;\n\t}\n\n\t.supportIcon {\n\t\twidth: 80px;\n\t\theight: 82.418px;\n\t}\n\n\t.supportIntroTitle {\n\t\tfont-size: 20px;\n\t\tfont-style: normal;\n\t\tfont-weight: 700;\n\t\tline-height: 150%; /* 30px */\n\t}\n\n\t.supportIntroTxt {\n\t\tfont-size: 13px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: 150%; /* 19.5px */\n\t}\n\n\t.supportActionButtonCon {\n\t\tmargin-top: 18px;\n\t\tpadding-bottom: 50px;\n\t}\n\n\t.supportActionButtonIcon {\n\t\twidth: 20px;\n\t\theight: 20px;\n\t}\n\n\t.supportActionButtonTxt {\n\t\tfont-size: 14px;\n\t}\n\n\t.faqText {\n\t\tfont-size: 16px;\n\t\tmargin-top: 44px;\n\t}\n\n\t.faqTitle,\n\t.faqMessage {\n\t\tfont-size: 14px;\n\t}\n\n\t.ticketingViewTForm {\n\t\tpadding: 18px;\n\t}\n}\n\n@media only screen and (max-width: 480px) and (min-width: 361px) {\n}\n\n@media only screen and (max-width: 360px) {\n}\n\n@media only screen and (max-height: 380px) and (min-height: 301px) {\n}\n\n@media only screen and (max-height: 300px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainParent": `Dashboard_mainParent__6N-X8`,
	"main": `Dashboard_main__eh3nW`,
	"showingTicketingView": `Dashboard_showingTicketingView__cWTPj`,
	"navBar": `Dashboard_navBar__lJ2n0`,
	"fixNavBarToView": `Dashboard_fixNavBarToView__jRTwO`,
	"profileButtonCon": `Dashboard_profileButtonCon__BC6Y4`,
	"profileIcon": `Dashboard_profileIcon__pDukT`,
	"username": `Dashboard_username__zSp4V`,
	"chevronDown": `Dashboard_chevronDown__1FSeK`,
	"black": `Dashboard_black__uXEMm`,
	"hello": `Dashboard_hello__Ct9kN`,
	"title": `Dashboard_title__gEkih`,
	"innerMain": `Dashboard_innerMain__UfXb6`,
	"tiles": `Dashboard_tiles__TgFmz`,
	"walBal": `Dashboard_walBal__yHhwT`,
	"card": `Dashboard_card__LuexR`,
	"cardMiddle": `Dashboard_cardMiddle__7JqJe`,
	"setVisibleCon": `Dashboard_setVisibleCon__umRq8`,
	"setVisible": `Dashboard_setVisible__xq29Z`,
	"currencyCon": `Dashboard_currencyCon__UE4tX`,
	"cChevronDown": `Dashboard_cChevronDown__67Nd-`,
	"flag": `Dashboard_flag__Jo0Q0`,
	"flagID": `Dashboard_flagID__7qg8R`,
	"cardBottom": `Dashboard_cardBottom__Ro34v`,
	"cardBox": `Dashboard_cardBox__VDoFG`,
	"cardCon": `Dashboard_cardCon__TNaEK`,
	"transactionsCon": `Dashboard_transactionsCon__fUrwV`,
	"kycParent": `Dashboard_kycParent__YGRYA`,
	"walVal": `Dashboard_walVal__Tfs9H`,
	"cardStrike": `Dashboard_cardStrike__UG5Aq`,
	"withdraw": `Dashboard_withdraw__mlogK`,
	"fund": `Dashboard_fund__ITGp7`,
	"notFocused": `Dashboard_notFocused__LucjL`,
	"littleCardIcon": `Dashboard_littleCardIcon__6m-GC`,
	"txn": `Dashboard_txn__UYWcK`,
	"txnIconCon": `Dashboard_txnIconCon__iuuZh`,
	"txnIcon": `Dashboard_txnIcon__z-wve`,
	"txnDetailCon": `Dashboard_txnDetailCon__cfn12`,
	"txnTitle": `Dashboard_txnTitle__dzUht`,
	"txnAmount": `Dashboard_txnAmount__CUjTG`,
	"txnMedium": `Dashboard_txnMedium__i0VDx`,
	"txnStatus": `Dashboard_txnStatus__81Tvw`,
	"txnSuccess": `Dashboard_txnSuccess__lXtPs`,
	"txnFail": `Dashboard_txnFail__S67Dp`,
	"txnsParent": `Dashboard_txnsParent__5xMig`,
	"bgBlank": `Dashboard_bgBlank__4S+mg`,
	"txnsTitleCon": `Dashboard_txnsTitleCon__NsS8D`,
	"cMore": `Dashboard_cMore__7357Y`,
	"cMoreText": `Dashboard_cMoreText__If5UO`,
	"cMoreChevron": `Dashboard_cMoreChevron__FbhAn`,
	"txnsCon": `Dashboard_txnsCon__XaVgJ`,
	"invTitle": `Dashboard_invTitle__UMfV9`,
	"preSale": `Dashboard_preSale__7LXpT`,
	"invIcon": `Dashboard_invIcon__Vc6jl`,
	"invLocation": `Dashboard_invLocation__N+2QD`,
	"invShares": `Dashboard_invShares__pXsro`,
	"invAmount": `Dashboard_invAmount__MMjUk`,
	"investmentsCon": `Dashboard_investmentsCon__Ey+RR`,
	"kycStepsCon": `Dashboard_kycStepsCon__Z8gnF`,
	"oStatus": `Dashboard_oStatus__eQyBT`,
	"oStatusProgressed": `Dashboard_oStatusProgressed__8OTvR`,
	"oStatusFailed": `Dashboard_oStatusFailed__tnPOp`,
	"oStatusExpanded": `Dashboard_oStatusExpanded__KwGfW`,
	"stepMarkCon": `Dashboard_stepMarkCon__xc3Eg`,
	"stepMarkConRejected": `Dashboard_stepMarkConRejected__aJgqr`,
	"stepMarkConPending": `Dashboard_stepMarkConPending__pTrzP`,
	"oStatusCon": `Dashboard_oStatusCon__rvZws`,
	"oStatusIconCon": `Dashboard_oStatusIconCon__aT4aM`,
	"oStatusIconConInner": `Dashboard_oStatusIconConInner__EHXP8`,
	"oStatusTop": `Dashboard_oStatusTop__38HQb`,
	"oStatusStage": `Dashboard_oStatusStage__rQQ0v`,
	"oStatusChevron": `Dashboard_oStatusChevron__sZih-`,
	"oStatusFlip": `Dashboard_oStatusFlip__YwXB8`,
	"flip90": `Dashboard_flip90__knavp`,
	"oStatusBottom": `Dashboard_oStatusBottom__P5u3R`,
	"oStatusContinue": `Dashboard_oStatusContinue__JL7oU`,
	"oStatusContinueIcon": `Dashboard_oStatusContinueIcon__wWyIx`,
	"oStatusNote": `Dashboard_oStatusNote__u2Gzj`,
	"profileGroup": `Dashboard_profileGroup__nHIg3`,
	"profileRow": `Dashboard_profileRow__nM7QO`,
	"userName": `Dashboard_userName__7B2oh`,
	"profileGroupDark": `Dashboard_profileGroupDark__2lsLZ`,
	"userSubName": `Dashboard_userSubName__vd9OV`,
	"profileGroupProfileIcon": `Dashboard_profileGroupProfileIcon__1xRex`,
	"profileGoupIcon": `Dashboard_profileGoupIcon__iF98+`,
	"profileGroupOption": `Dashboard_profileGroupOption__xWcQs`,
	"sTitleCon": `Dashboard_sTitleCon__oCBGq`,
	"iTitle": `Dashboard_iTitle__zsQVh`,
	"iProfit": `Dashboard_iProfit__1bfJz`,
	"iNegative": `Dashboard_iNegative__mD2Jd`,
	"selectorCon": `Dashboard_selectorCon__nfP4j`,
	"selectorB15": `Dashboard_selectorB15__NGv3G`,
	"sSelector": `Dashboard_sSelector__S7Eng`,
	"sPaddedSelector": `Dashboard_sPaddedSelector__n24X1`,
	"sSelSpan": `Dashboard_sSelSpan__1j-Go`,
	"sNotSelected": `Dashboard_sNotSelected__ffiOK`,
	"sBrowse": `Dashboard_sBrowse__91F8s`,
	"angel": `Dashboard_angel__qS4Er`,
	"sPlus": `Dashboard_sPlus__dVsG6`,
	"iPropertyParent": `Dashboard_iPropertyParent__XbuCV`,
	"iProperty": `Dashboard_iProperty__UmqEk`,
	"iPropertyImage": `Dashboard_iPropertyImage__pzf3d`,
	"iPropertyShares": `Dashboard_iPropertyShares__OzizB`,
	"iPropertyDetails": `Dashboard_iPropertyDetails__JBWSB`,
	"iPropertyName": `Dashboard_iPropertyName__VkpF0`,
	"iPropLeft": `Dashboard_iPropLeft__5utWq`,
	"iPropRight": `Dashboard_iPropRight__uNxbc`,
	"iPropertyProgress": `Dashboard_iPropertyProgress__SJ2-j`,
	"iViewDetailsBtnCon": `Dashboard_iViewDetailsBtnCon__aLr7C`,
	"iViewDetailsBtn": `Dashboard_iViewDetailsBtn__-SIVQ`,
	"tTitle": `Dashboard_tTitle__USDFF`,
	"tSubTitle": `Dashboard_tSubTitle__rcxbw`,
	"popupCon": `Dashboard_popupCon__55Y1u`,
	"popUpMask": `Dashboard_popUpMask__NXl+2`,
	"popup": `Dashboard_popup__V1tx6`,
	"popupSuccess": `Dashboard_popupSuccess__hTfaP`,
	"popupTitleCon": `Dashboard_popupTitleCon__vBKMf`,
	"popupTitle": `Dashboard_popupTitle__q0BIG`,
	"popupCloseCon": `Dashboard_popupCloseCon__2XMgC`,
	"popupCloseConSuccess": `Dashboard_popupCloseConSuccess__DcPMi`,
	"popupClose": `Dashboard_popupClose__xhd52`,
	"popupBody": `Dashboard_popupBody__wlwwI`,
	"popupBodySuccess": `Dashboard_popupBodySuccess__hr23g`,
	"popupCheckCon": `Dashboard_popupCheckCon__mcPcj`,
	"popupCheck": `Dashboard_popupCheck__RxS7w`,
	"popupSuccessTitle": `Dashboard_popupSuccessTitle__A34cX`,
	"popupSuccessMessage": `Dashboard_popupSuccessMessage__naGmL`,
	"txnTypeConParent": `Dashboard_txnTypeConParent__MwLr8`,
	"txnTypeCon": `Dashboard_txnTypeCon__iDmj0`,
	"fundRadio": `Dashboard_fundRadio__eYZXx`,
	"fundCTU": `Dashboard_fundCTU__DDwaC`,
	"fundLilDes": `Dashboard_fundLilDes__NbolO`,
	"walletForm": `Dashboard_walletForm__XUM1f`,
	"walletContinueCon": `Dashboard_walletContinueCon__ycDud`,
	"fundContinue": `Dashboard_fundContinue__bBwd-`,
	"dateSelectorCon": `Dashboard_dateSelectorCon__MZd38`,
	"dateSelectorConInner": `Dashboard_dateSelectorConInner__fUHd-`,
	"dateSelectorMonth": `Dashboard_dateSelectorMonth__8rnVt`,
	"boundsCon": `Dashboard_boundsCon__QfWTE`,
	"bound": `Dashboard_bound__d8Njr`,
	"tSelectorCon": `Dashboard_tSelectorCon__CKdmj`,
	"tTxnType": `Dashboard_tTxnType__1th1J`,
	"tMedium": `Dashboard_tMedium__MC+OJ`,
	"tTxnRecords": `Dashboard_tTxnRecords__Kxz9P`,
	"tStatus": `Dashboard_tStatus__+LnWE`,
	"tSSuccess": `Dashboard_tSSuccess__ygyhK`,
	"tSPending": `Dashboard_tSPending__W0O2C`,
	"tSFailed": `Dashboard_tSFailed__w4CDr`,
	"tDate": `Dashboard_tDate__UdeBT`,
	"tAmount": `Dashboard_tAmount__R5BKu`,
	"tBorder25": `Dashboard_tBorder25__lv6ee`,
	"tStatusIcon": `Dashboard_tStatusIcon__VWilF`,
	"tAmountCon": `Dashboard_tAmountCon__03hBJ`,
	"tinyProfileSection": `Dashboard_tinyProfileSection__6Ehwd`,
	"settingsViewCon": `Dashboard_settingsViewCon__QRkl9`,
	"settingsSwitch": `Dashboard_settingsSwitch__Seu+c`,
	"settingsSwitchBtn": `Dashboard_settingsSwitchBtn__Mezgw`,
	"settingSwitchBtn": `Dashboard_settingSwitchBtn__tG5xo`,
	"settingsSwitchInnerTag": `Dashboard_settingsSwitchInnerTag__k1JrL`,
	"settingsSwitchIcon": `Dashboard_settingsSwitchIcon__xguM2`,
	"selectedSettings": `Dashboard_selectedSettings__7daDw`,
	"settingsView": `Dashboard_settingsView__wxWsz`,
	"settingsProfileCon": `Dashboard_settingsProfileCon__RpH5g`,
	"settingsProfileIcon": `Dashboard_settingsProfileIcon__yidim`,
	"settingsProfileIconCon": `Dashboard_settingsProfileIconCon__gb+4C`,
	"settingsProfileTitle": `Dashboard_settingsProfileTitle__tAT-f`,
	"settingsProfileSubTitle": `Dashboard_settingsProfileSubTitle__wUhVI`,
	"settingsThick": `Dashboard_settingsThick__RXdKT`,
	"settingsThickLeft": `Dashboard_settingsThickLeft__CeCL4`,
	"settingsThickRight": `Dashboard_settingsThickRight__pSYjS`,
	"settingsLight": `Dashboard_settingsLight__uvqgc`,
	"settingsInfo": `Dashboard_settingsInfo__ppAHa`,
	"settingsInfoLeft": `Dashboard_settingsInfoLeft__bsA-B`,
	"settingsUploadButton": `Dashboard_settingsUploadButton__Sv-VJ`,
	"settingsInnerPfpCon": `Dashboard_settingsInnerPfpCon__wZORD`,
	"settingsProfileImage": `Dashboard_settingsProfileImage__2v78W`,
	"settingsUploadTag": `Dashboard_settingsUploadTag__XFdU+`,
	"settingUploadTxt": `Dashboard_settingUploadTxt__NcQid`,
	"settingsProfileArrow": `Dashboard_settingsProfileArrow__Y67x5`,
	"settingsViewSetViewBtn": `Dashboard_settingsViewSetViewBtn__MmQI+`,
	"settingsViewSetViewTxt": `Dashboard_settingsViewSetViewTxt__6tmM4`,
	"settingsViewSetViewIcon": `Dashboard_settingsViewSetViewIcon__eqmym`,
	"settingsPasswordChangeForm": `Dashboard_settingsPasswordChangeForm__Z+eRR`,
	"settingsPasswordInputCon": `Dashboard_settingsPasswordInputCon__FU4oc`,
	"settingsPasswordInputLabel": `Dashboard_settingsPasswordInputLabel__MeFBI`,
	"settingsPasswordInput": `Dashboard_settingsPasswordInput__o+OkC`,
	"settingsPasswordChangeBtn": `Dashboard_settingsPasswordChangeBtn__nFAuI`,
	"inputHidden": `Dashboard_inputHidden__GuRfO`,
	"supportParent": `Dashboard_supportParent__K3LsZ`,
	"supportIcon": `Dashboard_supportIcon__Ac2Lw`,
	"supportIntroCon": `Dashboard_supportIntroCon__UcCyY`,
	"supportIntroTitle": `Dashboard_supportIntroTitle__z0Zvu`,
	"supportIntroTxt": `Dashboard_supportIntroTxt__XBf+s`,
	"supportActionButtonCon": `Dashboard_supportActionButtonCon__QatRa`,
	"supportActionButton": `Dashboard_supportActionButton__bvgr9`,
	"supportActionButtonPurple": `Dashboard_supportActionButtonPurple__WmzoT`,
	"supportActionButtonBlack": `Dashboard_supportActionButtonBlack__8LULv`,
	"supportActionButtonIcon": `Dashboard_supportActionButtonIcon__MMi0j`,
	"supportActionButtonTxt": `Dashboard_supportActionButtonTxt__09meB`,
	"supportTicketParent": `Dashboard_supportTicketParent__a4wsA`,
	"supportTicketInfoCon": `Dashboard_supportTicketInfoCon__6JXUO`,
	"supportTicketIconCon": `Dashboard_supportTicketIconCon__bnHMq`,
	"supportTicketIcon": `Dashboard_supportTicketIcon__Pbmm7`,
	"supportTicketTitleCon": `Dashboard_supportTicketTitleCon__N-UBU`,
	"supportTicketTitle": `Dashboard_supportTicketTitle__nhsvU`,
	"supportTicketStatusCon": `Dashboard_supportTicketStatusCon__6CJvX`,
	"supportTicketStatusOpen": `Dashboard_supportTicketStatusOpen__DbLrq`,
	"supportTicketStatusClosed": `Dashboard_supportTicketStatusClosed__W+qPm`,
	"supportTicketStatusTxt": `Dashboard_supportTicketStatusTxt__vvemk`,
	"supportTicketMessage": `Dashboard_supportTicketMessage__c20st`,
	"supportTicketChevronIcon": `Dashboard_supportTicketChevronIcon__wfBOS`,
	"faqText": `Dashboard_faqText__gKIj6`,
	"faqs": `Dashboard_faqs__-6SVX`,
	"fapCon": `Dashboard_fapCon__3cBT3`,
	"faqTitle": `Dashboard_faqTitle__o8yAV`,
	"faqIcon": `Dashboard_faqIcon__48rJ4`,
	"faqMessage": `Dashboard_faqMessage__raax2`,
	"ticketingViewArc": `Dashboard_ticketingViewArc__sXnQ8`,
	"ticketingView": `Dashboard_ticketingView__9WrJM`,
	"ticketingViewExit": `Dashboard_ticketingViewExit__Vw9Mb`,
	"ticketingViewExitIcon": `Dashboard_ticketingViewExitIcon__Ykpup`,
	"ticketingViewExitTxt": `Dashboard_ticketingViewExitTxt__BvRcF`,
	"ticketingViewTicketingCon": `Dashboard_ticketingViewTicketingCon__kTGtQ`,
	"ticketingViewTForm": `Dashboard_ticketingViewTForm__rEkVw`,
	"ticketingViewTFormTitle": `Dashboard_ticketingViewTFormTitle__duDzY`,
	"showTicketingMask": `Dashboard_showTicketingMask__YS02Z`,
	"ticketingMaskActive": `Dashboard_ticketingMaskActive__7HIbQ`,
	"ticketingInputCon": `Dashboard_ticketingInputCon__2qSnH`,
	"ticketingViewComplaintNotice": `Dashboard_ticketingViewComplaintNotice__1VFeP`,
	"ticketingViewFileUploadTitle": `Dashboard_ticketingViewFileUploadTitle__QeAp8`,
	"ticketingViewSubmitBtn": `Dashboard_ticketingViewSubmitBtn__LZZSc`,
	"ticketingViewCreatedTickets": `Dashboard_ticketingViewCreatedTickets__SSfp+`,
	"ticketingViewCreatedTicketsTitle": `Dashboard_ticketingViewCreatedTicketsTitle__6EgFl`,
	"ticketingViewCreatedTicketsCon": `Dashboard_ticketingViewCreatedTicketsCon__+LdX6`,
	"b18": `Dashboard_b18__tpj1I`,
	"cashOutAmountCon": `Dashboard_cashOutAmountCon__ZO29l`,
	"cashOutAmountValueCon": `Dashboard_cashOutAmountValueCon__KX0nM`,
	"emptyQuery": `Dashboard_emptyQuery__DYKwq`,
	"emptyQueryTitle": `Dashboard_emptyQueryTitle__MmrgZ`,
	"emptyQueryMessage": `Dashboard_emptyQueryMessage__cdl1e`,
	"emptyRealEstate": `Dashboard_emptyRealEstate__L959-`,
	"emptyRealEstateMini": `Dashboard_emptyRealEstateMini__0D3ZX`,
	"cta": `Dashboard_cta__kaqkd`,
	"ctaTitle": `Dashboard_ctaTitle__y63HC`,
	"ctaText": `Dashboard_ctaText__nZ+k1`,
	"sActionButtons": `Dashboard_sActionButtons__vI2PF`,
	"noMargin": `Dashboard_noMargin__pgcf5`,
	"txnsCon_": `Dashboard_txnsCon___VLJyC`,
	"tinyMonthCon": `Dashboard_tinyMonthCon__e6518`,
	"txnsParent_": `Dashboard_txnsParent___ypwFb`,
	"tTypeMedium": `Dashboard_tTypeMedium__1QZue`,
	"iPropertyListing": `Dashboard_iPropertyListing__fpZCm`,
	"iPlus": `Dashboard_iPlus__02nWE`,
	"settingsSwitchTag": `Dashboard_settingsSwitchTag__Z3O1v`,
	"neutral": `Dashboard_neutral__61QvX`
};
export default ___CSS_LOADER_EXPORT___;
